var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipPathImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 63,
    viewBox: "0 0 77 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18283_19882",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: -60,
    width: 237,
    height: 237
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4326 176.966L223.967 98.5332L145.534 -60.0008L-12.9998 18.4318L65.4326 176.966Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18283_19882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9183 61.4237C76.6541 61.5544 76.5456 61.8753 76.6764 62.1395C76.8071 62.4038 77.128 62.5122 77.3922 62.3815C77.6564 62.2507 77.7649 61.9299 77.6341 61.6656C77.5034 61.4014 77.1825 61.293 76.9183 61.4237Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0949 62.8475C73.8417 62.9727 73.7388 63.2772 73.8641 63.5304C73.9894 63.7836 74.2938 63.8865 74.547 63.7612C74.8002 63.6359 74.9031 63.3315 74.7779 63.0783C74.6526 62.8251 74.3481 62.7222 74.0949 62.8475Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9284 57.8715C76.6548 58.0069 76.5428 58.3384 76.6781 58.612C76.8135 58.8856 77.145 58.9977 77.4187 58.8623C77.6923 58.7269 77.8043 58.3954 77.6689 58.1218C77.5336 57.8482 77.202 57.7361 76.9284 57.8715Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.096 59.2909C73.8316 59.4217 73.7232 59.7422 73.8541 60.0067C73.985 60.2712 74.3055 60.3795 74.5699 60.2487C74.8344 60.1178 74.9427 59.7973 74.8119 59.5328C74.681 59.2683 74.3605 59.16 74.096 59.2909Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2707 60.7127C71.0175 60.838 70.9146 61.1424 71.0399 61.3956C71.1652 61.6488 71.4696 61.7517 71.7228 61.6264C71.976 61.5012 72.0789 61.1967 71.9536 60.9435C71.8284 60.6903 71.5239 60.5874 71.2707 60.7127Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4395 62.1423C68.2028 62.2594 68.1 62.5501 68.2198 62.7923C68.3397 63.0345 68.6276 63.1319 68.8698 63.012C69.112 62.8922 69.2094 62.6042 69.0895 62.362C68.9697 62.1198 68.6817 62.0225 68.4395 62.1423Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9341 54.3242C76.6533 54.4631 76.5448 54.7977 76.681 55.0729C76.8172 55.3481 77.1545 55.4621 77.4298 55.326C77.705 55.1898 77.819 54.8524 77.6828 54.5772C77.5466 54.302 77.2093 54.188 76.9341 54.3242Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1044 55.7391C73.8338 55.873 73.723 56.2009 73.8569 56.4714C73.9908 56.742 74.3186 56.8528 74.5892 56.719C74.8598 56.5851 74.9706 56.2572 74.8367 55.9867C74.7028 55.7161 74.375 55.6053 74.1044 55.7391Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2798 57.1644C71.0211 57.2924 70.91 57.6078 71.0407 57.872C71.1714 58.1362 71.4841 58.2419 71.7483 58.1112C72.0125 57.9804 72.1182 57.6678 71.9875 57.4036C71.8567 57.1394 71.5441 57.0337 71.2798 57.1644Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4484 58.5818C68.1952 58.7071 68.0923 59.0116 68.2176 59.2648C68.3429 59.518 68.6473 59.6209 68.9005 59.4956C69.1538 59.3703 69.2567 59.0659 69.1314 58.8127C69.0061 58.5595 68.7017 58.4566 68.4484 58.5818Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.618 59.9954C65.3758 60.1152 65.2757 60.4114 65.3955 60.6536C65.5154 60.8958 65.8116 60.9959 66.0538 60.8761C66.296 60.7563 66.3961 60.46 66.2763 60.2178C66.1564 59.9756 65.8602 59.8755 65.618 59.9954Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7856 61.4187C62.5516 61.5345 62.4557 61.8181 62.5715 62.0522C62.6873 62.2863 62.971 62.3822 63.2051 62.2664C63.4391 62.1505 63.535 61.8669 63.4192 61.6328C63.3034 61.3987 63.0197 61.3028 62.7856 61.4187Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9581 62.8361C59.7332 62.9474 59.641 63.22 59.7524 63.445C59.8637 63.6699 60.1363 63.7621 60.3612 63.6508C60.5862 63.5394 60.6783 63.2668 60.567 63.0419C60.4557 62.8169 60.1831 62.7248 59.9581 62.8361Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9334 50.7461C76.6361 50.8932 76.5083 51.258 76.6581 51.5607C76.8079 51.8635 77.1699 51.9858 77.4726 51.836C77.7754 51.6862 77.8977 51.3242 77.7479 51.0215C77.5982 50.7187 77.2361 50.5964 76.9334 50.7461Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1029 52.1616C73.8112 52.306 73.6916 52.6598 73.836 52.9515C73.9803 53.2432 74.3341 53.3628 74.6259 53.2185C74.9176 53.0741 75.0372 52.7203 74.8928 52.4286C74.7485 52.1369 74.3947 52.0173 74.1029 52.1616Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2696 53.581C70.9889 53.7199 70.8721 54.0655 71.011 54.3462C71.1499 54.6269 71.4954 54.7437 71.7762 54.6048C72.0569 54.4659 72.1737 54.1204 72.0348 53.8396C71.8959 53.5589 71.5503 53.4421 71.2696 53.581Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4431 55.0004C68.1678 55.1366 68.0566 55.4657 68.1928 55.7409C68.329 56.0162 68.6581 56.1274 68.9333 55.9912C69.2085 55.855 69.3198 55.5259 69.1836 55.2507C69.0474 54.9755 68.7183 54.8642 68.4431 55.0004Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6213 56.4432C65.3681 56.5684 65.2652 56.8729 65.3905 57.1261C65.5158 57.3793 65.8202 57.4822 66.0734 57.3569C66.3266 57.2316 66.4295 56.9272 66.3042 56.674C66.1789 56.4208 65.8745 56.3179 65.6213 56.4432Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7957 57.8606C62.5536 57.9804 62.4534 58.2766 62.5733 58.5188C62.6931 58.761 62.9893 58.8612 63.2315 58.7413C63.4737 58.6215 63.5738 58.3253 63.454 58.0831C63.3342 57.8409 63.0379 57.7408 62.7957 57.8606Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9678 59.2771C59.7311 59.3942 59.6283 59.6849 59.7481 59.9271C59.868 60.1693 60.156 60.2666 60.3982 60.1468C60.6404 60.027 60.7377 59.739 60.6178 59.4968C60.498 59.2546 60.21 59.1573 59.9678 59.2771Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.126 60.6833C56.8894 60.8004 56.7865 61.0911 56.9063 61.3333C57.0262 61.5755 57.3142 61.6729 57.5564 61.553C57.7986 61.4332 57.8959 61.1452 57.7761 60.903C57.6562 60.6608 57.3682 60.5635 57.126 60.6833Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2956 62.0949C54.0644 62.2093 53.9699 62.4891 54.0843 62.7202C54.1986 62.9514 54.4784 63.046 54.7096 62.9316C54.9408 62.8172 55.0353 62.5375 54.9209 62.3063C54.8066 62.0751 54.5268 61.9805 54.2956 62.0949Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.95 47.2032C76.6527 47.3502 76.5249 47.715 76.6747 48.0178C76.8245 48.3205 77.1865 48.4429 77.4892 48.2931C77.792 48.1433 77.9143 47.7812 77.7646 47.4785C77.6148 47.1758 77.2527 47.0534 76.95 47.2032Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1166 48.6265C73.8249 48.7708 73.7053 49.1246 73.8497 49.4164C73.994 49.7081 74.3478 49.8277 74.6395 49.6833C74.9313 49.539 75.0509 49.1852 74.9065 48.8934C74.7622 48.6017 74.4084 48.4821 74.1166 48.6265Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2891 50.0439C71.0084 50.1828 70.8916 50.5284 71.0305 50.8091C71.1694 51.0898 71.515 51.2066 71.7957 51.0677C72.0764 50.9288 72.1932 50.5833 72.0543 50.3025C71.9154 50.0218 71.5699 49.905 71.2891 50.0439Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4616 51.4613C68.188 51.5967 68.076 51.9283 68.2113 52.2019C68.3467 52.4755 68.6783 52.5875 68.9519 52.4522C69.2255 52.3168 69.3375 51.9852 69.2022 51.7116C69.0668 51.438 68.7352 51.326 68.4616 51.4613Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6302 52.8846C65.3657 53.0155 65.2574 53.336 65.3883 53.6005C65.5191 53.865 65.8396 53.9733 66.1041 53.8424C66.3686 53.7116 66.4769 53.3911 66.3461 53.1266C66.2152 52.8621 65.8947 52.7538 65.6302 52.8846Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8059 54.3064C62.5527 54.4317 62.4498 54.7362 62.575 54.9894C62.7003 55.2426 63.0048 55.3455 63.258 55.2202C63.5112 55.0949 63.6141 54.7905 63.4888 54.5373C63.3635 54.2841 63.0591 54.1812 62.8059 54.3064Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9725 55.7297C59.7303 55.8496 59.6302 56.1458 59.75 56.388C59.8699 56.6302 60.1661 56.7303 60.4083 56.6105C60.6505 56.4906 60.7506 56.1944 60.6308 55.9522C60.5109 55.71 60.2147 55.6099 59.9725 55.7297Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1397 57.1384C56.903 57.2555 56.8002 57.5462 56.92 57.7884C57.0399 58.0306 57.3278 58.128 57.57 58.0081C57.8122 57.8883 57.9096 57.6003 57.7897 57.3581C57.6699 57.1159 57.3819 57.0186 57.1397 57.1384Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3132 58.5559C54.0821 58.6702 53.9875 58.9501 54.1018 59.1812C54.2162 59.4122 54.4961 59.5069 54.7272 59.3925C54.9582 59.2782 55.0528 58.9983 54.9385 58.7672C54.8242 58.5362 54.5442 58.4415 54.3132 58.5559Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4842 59.984C51.2695 60.0902 51.1805 60.3535 51.2867 60.5682C51.3929 60.7829 51.6562 60.8718 51.8709 60.7656C52.0856 60.6594 52.1746 60.3961 52.0683 60.1814C51.9621 59.9668 51.6988 59.8778 51.4842 59.984Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6565 61.401C48.4473 61.5045 48.3611 61.7595 48.4646 61.9687C48.5681 62.1779 48.8231 62.2641 49.0323 62.1606C49.2415 62.0571 49.3277 61.802 49.2242 61.5928C49.1207 61.3837 48.8656 61.2975 48.6565 61.401Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.829 62.8204C45.6308 62.9184 45.5446 63.1597 45.6454 63.3634C45.7462 63.5671 45.9848 63.6477 46.1885 63.5469C46.3921 63.4462 46.4728 63.2076 46.372 63.0039C46.2712 62.8002 46.0326 62.7196 45.829 62.8204Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9544 43.6534C76.6462 43.8059 76.521 44.1762 76.6736 44.4844C76.8261 44.7927 77.1963 44.9178 77.5046 44.7653C77.8128 44.6128 77.938 44.2425 77.7855 43.9343C77.633 43.626 77.2627 43.5009 76.9544 43.6534Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1185 45.0557C73.8115 45.2077 73.6857 45.5797 73.8376 45.8868C73.9895 46.1938 74.3616 46.3196 74.6687 46.1677C74.9757 46.0157 75.1015 45.6437 74.9495 45.3366C74.7976 45.0296 74.4256 44.9038 74.1185 45.0557Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2918 46.4727C70.9945 46.6198 70.8667 46.9845 71.0165 47.2873C71.1663 47.59 71.5283 47.7124 71.831 47.5626C72.1338 47.4128 72.2561 47.0508 72.1063 46.748C71.9566 46.4453 71.5945 46.3229 71.2918 46.4727Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 47.8969C68.176 48.0383 68.059 48.3846 68.2004 48.6704C68.3418 48.9561 68.688 49.0732 68.9738 48.9318C69.2596 48.7904 69.3766 48.4441 69.2352 48.1584C69.0938 47.8726 68.7475 47.7555 68.4618 47.8969Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6352 49.3202C65.3586 49.4571 65.2453 49.7923 65.3822 50.069C65.5191 50.3456 65.8543 50.4589 66.1309 50.3221C66.4076 50.1852 66.5209 49.85 66.384 49.5733C66.2471 49.2967 65.9119 49.1834 65.6352 49.3202Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8091 50.7562C62.5504 50.8842 62.4393 51.1996 62.57 51.4638C62.7007 51.728 63.0134 51.8337 63.2776 51.703C63.5418 51.5722 63.6475 51.2596 63.5168 50.9954C63.386 50.7311 63.0734 50.6255 62.8091 50.7562Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9816 52.1736C59.7284 52.2989 59.6255 52.6034 59.7508 52.8566C59.8761 53.1098 60.1805 53.2127 60.4338 53.0874C60.687 52.9621 60.7899 52.6577 60.6646 52.4045C60.5393 52.1512 60.2349 52.0484 59.9816 52.1736Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1522 53.5872C56.909 53.7075 56.8094 54.0022 56.9297 54.2454C57.0501 54.4886 57.3448 54.5882 57.588 54.4679C57.8312 54.3475 57.9308 54.0528 57.8104 53.8096C57.6901 53.5664 57.3954 53.4668 57.1522 53.5872Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3133 54.9934C54.0701 55.1137 53.9705 55.4084 54.0908 55.6517C54.2112 55.8949 54.5059 55.9945 54.7491 55.8741C54.9923 55.7538 55.0919 55.4591 54.9716 55.2159C54.8512 54.9727 54.5565 54.8731 54.3133 54.9934Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.487 56.4191C51.256 56.5335 51.1613 56.8134 51.2757 57.0445C51.39 57.2755 51.67 57.3701 51.901 57.2558C52.132 57.1415 52.2267 56.8615 52.1124 56.6305C51.998 56.3994 51.7181 56.3048 51.487 56.4191Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6625 57.8424C48.4423 57.9514 48.3505 58.2229 48.4594 58.4431C48.5684 58.6632 48.8399 58.755 49.0601 58.6461C49.2803 58.5371 49.372 58.2656 49.2631 58.0454C49.1542 57.8253 48.8826 57.7335 48.6625 57.8424Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8281 59.2599C45.6134 59.3661 45.5272 59.6212 45.6334 59.8358C45.7397 60.0505 45.9947 60.1367 46.2094 60.0305C46.4241 59.9243 46.5103 59.6692 46.4041 59.4545C46.2979 59.2399 46.0428 59.1537 45.8281 59.2599Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.011 60.6963C42.8129 60.7943 42.7377 61.0302 42.833 61.2229C42.9284 61.4155 43.167 61.4962 43.3596 61.4009C43.5523 61.3055 43.6329 61.0669 43.5376 60.8743C43.4423 60.6816 43.2037 60.601 43.011 60.6963Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1876 62.12C40.0052 62.2103 39.9305 62.4313 40.0208 62.6137C40.111 62.7961 40.3321 62.8708 40.5145 62.7806C40.6969 62.6903 40.7716 62.4693 40.6813 62.2869C40.5911 62.1045 40.37 62.0298 40.1876 62.12Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9571 40.0803C76.6318 40.2412 76.4986 40.6354 76.6595 40.9607C76.8205 41.2859 77.2146 41.4192 77.5399 41.2582C77.8652 41.0973 77.9984 40.7031 77.8375 40.3778C77.6765 40.0525 77.2824 39.9193 76.9571 40.0803Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1276 41.5016C73.8115 41.658 73.682 42.0411 73.8384 42.3573C73.9949 42.6735 74.378 42.803 74.6941 42.6465C75.0103 42.4901 75.1398 42.107 74.9834 41.7908C74.8269 41.4747 74.4438 41.3452 74.1276 41.5016Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2962 42.9229C70.988 43.0754 70.8629 43.4457 71.0154 43.754C71.1679 44.0622 71.5381 44.1874 71.8464 44.0348C72.1546 43.8823 72.2798 43.5121 72.1273 43.2038C71.9748 42.8956 71.6045 42.7704 71.2962 42.9229Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4685 44.3418C68.1713 44.4889 68.0434 44.8537 68.1932 45.1564C68.343 45.4592 68.705 45.5815 69.0078 45.4317C69.3105 45.2819 69.4329 44.9199 69.2831 44.6172C69.1333 44.3144 68.7713 44.192 68.4685 44.3418Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6434 45.7641C65.3572 45.9058 65.2404 46.2513 65.382 46.5376C65.5236 46.8238 65.8692 46.9406 66.1554 46.799C66.4417 46.6574 66.5585 46.3118 66.4168 46.0256C66.2752 45.7393 65.9296 45.6225 65.6434 45.7641Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.812 47.1874C62.5354 47.3243 62.4221 47.6595 62.5589 47.9362C62.6958 48.2128 63.031 48.3261 63.3077 48.1892C63.5843 48.0524 63.6976 47.7171 63.5608 47.4405C63.4239 47.1639 63.0886 47.0506 62.812 47.1874Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9814 48.6005C59.7108 48.7343 59.6 49.0622 59.7339 49.3328C59.8677 49.6033 60.1956 49.7142 60.4662 49.5803C60.7367 49.4464 60.8475 49.1186 60.7137 48.848C60.5798 48.5774 60.2519 48.4666 59.9814 48.6005Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.149 50.0199C56.8903 50.1479 56.7791 50.4633 56.9098 50.7275C57.0406 50.9917 57.3532 51.0974 57.6174 50.9666C57.8816 50.8359 57.9873 50.5233 57.8566 50.259C57.7259 49.9948 57.4132 49.8892 57.149 50.0199Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3234 51.4393C54.0702 51.5645 53.9673 51.869 54.0926 52.1222C54.2179 52.3754 54.5223 52.4783 54.7755 52.353C55.0288 52.2277 55.1317 51.9233 55.0064 51.6701C54.8811 51.4169 54.5767 51.314 54.3234 51.4393Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.494 52.8567C51.2518 52.9765 51.1517 53.2727 51.2715 53.5149C51.3914 53.7571 51.6876 53.8572 51.9298 53.7374C52.172 53.6176 52.2721 53.3214 52.1522 53.0792C52.0324 52.837 51.7362 52.7369 51.494 52.8567Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6657 54.2883C48.4347 54.4026 48.3401 54.6826 48.4544 54.9136C48.5687 55.1446 48.8487 55.2393 49.0797 55.125C49.3108 55.0106 49.4054 54.7307 49.2911 54.4996C49.1767 54.2686 48.8968 54.174 48.6657 54.2883Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8372 55.7018C45.6153 55.8116 45.5244 56.0805 45.6342 56.3024C45.744 56.5244 46.013 56.6153 46.2349 56.5055C46.4568 56.3957 46.5477 56.1267 46.4379 55.9048C46.3281 55.6829 46.0592 55.592 45.8372 55.7018Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0107 57.1212C42.7979 57.2265 42.7108 57.4843 42.8161 57.6971C42.9214 57.91 43.1792 57.9971 43.392 57.8918C43.6048 57.7865 43.692 57.5287 43.5867 57.3159C43.4814 57.1031 43.2235 57.0159 43.0107 57.1212Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1793 58.5406C39.9757 58.6413 39.8922 58.8882 39.993 59.0919C40.0938 59.2955 40.3406 59.3789 40.5443 59.2782C40.748 59.1774 40.8314 58.9306 40.7306 58.7269C40.6298 58.5232 40.383 58.4398 40.1793 58.5406Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3528 59.9658C37.1546 60.0639 37.0795 60.2998 37.1748 60.4924C37.2702 60.6851 37.5088 60.7657 37.7014 60.6704C37.8941 60.5751 37.9747 60.3365 37.8794 60.1438C37.7841 59.9511 37.5455 59.8705 37.3528 59.9658Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5275 61.3857C34.3451 61.4759 34.2704 61.697 34.3606 61.8794C34.4509 62.0618 34.6719 62.1365 34.8543 62.0462C35.0367 61.956 35.1114 61.735 35.0212 61.5525C34.9309 61.3701 34.7099 61.2954 34.5275 61.3857Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6941 62.809C31.5208 62.8947 31.4499 63.1047 31.5356 63.278C31.6213 63.4513 31.8313 63.5222 32.0046 63.4365C32.1779 63.3508 32.2489 63.1408 32.1631 62.9675C32.0774 62.7942 31.8674 62.7232 31.6941 62.809Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9662 36.5281C76.6305 36.6942 76.4942 37.0974 76.6603 37.4331C76.8264 37.7689 77.2296 37.9052 77.5654 37.739C77.9012 37.5729 78.0374 37.1697 77.8713 36.834C77.7052 36.4982 77.302 36.3619 76.9662 36.5281Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.136 37.9577C73.8138 38.1171 73.6818 38.5076 73.8412 38.8298C74.0007 39.1521 74.3912 39.2841 74.7134 39.1246C75.0356 38.9652 75.1676 38.5747 75.0082 38.2525C74.8487 37.9302 74.4583 37.7982 74.136 37.9577Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2991 39.3581C70.9769 39.5175 70.8449 39.908 71.0043 40.2302C71.1638 40.5525 71.5542 40.6845 71.8765 40.525C72.1987 40.3656 72.3307 39.9751 72.1713 39.6529C72.0118 39.3306 71.6213 39.1986 71.2991 39.3581Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4736 40.7755C68.1604 40.9304 68.0322 41.3099 68.1871 41.623C68.342 41.9361 68.7215 42.0644 69.0346 41.9094C69.3477 41.7545 69.476 41.3751 69.321 41.0619C69.1661 40.7488 68.7867 40.6206 68.4736 40.7755Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6422 42.1968C65.3394 42.3466 65.2143 42.7169 65.3641 43.0196C65.5138 43.3224 65.8841 43.4475 66.1869 43.2977C66.4896 43.1479 66.6147 42.7777 66.465 42.4749C66.3152 42.1722 65.9449 42.047 65.6422 42.1968Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8147 43.6162C62.5174 43.7633 62.4006 44.1226 62.5449 44.4143C62.6892 44.7061 63.0513 44.8284 63.343 44.6841C63.6348 44.5398 63.7571 44.1777 63.6128 43.886C63.4684 43.5942 63.1064 43.4719 62.8147 43.6162Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9868 45.0507C59.7061 45.1896 59.5976 45.5242 59.7337 45.7995C59.8699 46.0747 60.2073 46.1887 60.4825 46.0525C60.7577 45.9164 60.8717 45.579 60.7356 45.3038C60.5994 45.0286 60.262 44.9145 59.9868 45.0507Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1644 46.4803C56.8999 46.6112 56.7916 46.9317 56.9225 47.1962C57.0533 47.4607 57.3738 47.569 57.6383 47.4381C57.9028 47.3073 58.0111 46.9868 57.8802 46.7223C57.7494 46.4578 57.4289 46.3495 57.1644 46.4803Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.334 47.8919C54.0753 48.0199 53.9751 48.3299 54.1004 48.5831C54.2257 48.8363 54.5383 48.9419 54.7915 48.8167C55.0447 48.6914 55.1504 48.3787 55.0251 48.1255C54.8999 47.8723 54.5872 47.7666 54.334 47.8919Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4951 49.2982C51.2364 49.4262 51.1362 49.7361 51.2615 49.9893C51.3868 50.2425 51.6995 50.3482 51.9527 50.2229C52.2059 50.0976 52.3115 49.785 52.1863 49.5318C52.061 49.2786 51.7483 49.1729 51.4951 49.2982Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6647 50.7117C48.417 50.8342 48.3169 51.1305 48.4394 51.3782C48.562 51.6259 48.8582 51.726 49.1059 51.6034C49.3536 51.4809 49.4537 51.1847 49.3312 50.9369C49.2086 50.6892 48.9124 50.5891 48.6647 50.7117Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8399 52.1345C45.6032 52.2516 45.5004 52.5423 45.6202 52.7845C45.74 53.0267 46.028 53.1241 46.2702 53.0042C46.5124 52.8844 46.6098 52.5964 46.4899 52.3542C46.3701 52.112 46.0821 52.0147 45.8399 52.1345Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0075 53.5559C42.7765 53.6702 42.6819 53.9501 42.7962 54.1812C42.9105 54.4122 43.1905 54.5069 43.4215 54.3925C43.6525 54.2782 43.7472 53.9983 43.6329 53.7672C43.5185 53.5362 43.2386 53.4415 43.0075 53.5559Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1926 54.9967C39.9834 55.1002 39.8972 55.3552 40.0007 55.5644C40.1042 55.7736 40.3593 55.8598 40.5684 55.7563C40.7776 55.6528 40.8638 55.3977 40.7603 55.1885C40.6568 54.9794 40.4018 54.8932 40.1926 54.9967Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3665 56.4209C37.1683 56.5189 37.0932 56.7548 37.1885 56.9475C37.2838 57.1402 37.5224 57.2208 37.7151 57.1255C37.9078 57.0302 37.9884 56.7915 37.8931 56.5989C37.7978 56.4062 37.5591 56.3256 37.3665 56.4209Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.538 57.8481C34.3526 57.9399 34.2766 58.1646 34.3684 58.35C34.4601 58.5355 34.6848 58.6114 34.8703 58.5197C35.0557 58.4279 35.1317 58.2032 35.0399 58.0177C34.9482 57.8323 34.7235 57.7563 34.538 57.8481Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7021 59.2465C31.5166 59.3383 31.4407 59.563 31.5324 59.7484C31.6242 59.9339 31.8489 60.0098 32.0343 59.9181C32.2198 59.8263 32.2957 59.6016 32.204 59.4162C32.1122 59.2307 31.8875 59.1548 31.7021 59.2465Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8724 60.6635C28.6963 60.7507 28.6185 60.9673 28.7083 61.149C28.7982 61.3306 29.0121 61.4029 29.1938 61.313C29.3754 61.2232 29.4477 61.0092 29.3579 60.8276C29.268 60.6459 29.0541 60.5736 28.8724 60.6635Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0391 62.0848C25.8684 62.1693 25.7989 62.375 25.8833 62.5456C25.9678 62.7162 26.1735 62.7858 26.3441 62.7013C26.5147 62.6169 26.5843 62.4112 26.4998 62.2406C26.4154 62.0699 26.2097 62.0004 26.0391 62.0848Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9715 32.9778C76.6302 33.1467 76.4884 33.5663 76.6572 33.9076C76.8261 34.2489 77.2457 34.3907 77.587 34.2218C77.9283 34.053 78.0701 33.6333 77.9012 33.2921C77.7324 32.9508 77.3127 32.809 76.9715 32.9778Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.142 34.3894C73.8062 34.5555 73.67 34.9587 73.8361 35.2945C74.0022 35.6302 74.4054 35.7665 74.7412 35.6004C75.077 35.4342 75.2132 35.0311 75.0471 34.6953C74.881 34.3595 74.4778 34.2232 74.142 34.3894Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3157 35.8151C70.9935 35.9745 70.8615 36.365 71.0209 36.6873C71.1804 37.0095 71.5708 37.1415 71.8931 36.9821C72.2153 36.8226 72.3473 36.4321 72.1879 36.1099C72.0284 35.7876 71.6379 35.6557 71.3157 35.8151Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4872 37.2443C68.1735 37.3995 68.0455 37.778 68.2008 38.0917C68.356 38.4055 68.7345 38.5334 69.0483 38.3782C69.362 38.2229 69.49 37.8445 69.3347 37.5307C69.1795 37.2169 68.801 37.089 68.4872 37.2443Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6558 38.6558C65.3531 38.8056 65.2279 39.1759 65.3777 39.4786C65.5275 39.7814 65.8978 39.9065 66.2005 39.7567C66.5033 39.6069 66.6284 39.2367 66.4786 38.9339C66.3288 38.6312 65.9586 38.506 65.6558 38.6558Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8293 40.0733C62.5321 40.2203 62.4152 40.5796 62.5595 40.8714C62.7039 41.1631 63.0659 41.2855 63.3577 41.1411C63.6494 40.9968 63.7718 40.6348 63.6274 40.343C63.4831 40.0513 63.1265 39.9262 62.8293 40.0733Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9969 41.4927C59.7107 41.6343 59.5939 41.9798 59.7355 42.2661C59.8771 42.5523 60.2227 42.6691 60.5089 42.5275C60.7952 42.3859 60.912 42.0403 60.7704 41.7541C60.6287 41.4678 60.2832 41.351 59.9969 41.4927Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1704 42.914C56.8938 43.0509 56.7805 43.3861 56.9173 43.6627C57.0542 43.9394 57.3894 44.0527 57.6661 43.9158C57.9427 43.7789 58.056 43.4437 57.9192 43.1671C57.7823 42.8904 57.447 42.7771 57.1704 42.914Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3402 44.3417C54.076 44.4724 53.9675 44.7933 54.0982 45.0575C54.229 45.3217 54.5499 45.4302 54.8141 45.2994C55.0783 45.1687 55.1867 44.8478 55.056 44.5836C54.9253 44.3194 54.6044 44.2109 54.3402 44.3417Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5117 45.7571C51.253 45.8851 51.1528 46.1951 51.2781 46.4483C51.4034 46.7015 51.7161 46.8072 51.9693 46.6819C52.2225 46.5566 52.3281 46.2439 52.2029 45.9907C52.0776 45.7375 51.7649 45.6319 51.5117 45.7571Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6852 47.1765C48.4375 47.2991 48.3374 47.5953 48.4599 47.843C48.5825 48.0907 48.8787 48.1908 49.1264 48.0683C49.3741 47.9457 49.4742 47.6495 49.3517 47.4018C49.2291 47.1541 48.9329 47.054 48.6852 47.1765Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8526 48.5994C45.6159 48.7165 45.5131 49.0072 45.6329 49.2494C45.7527 49.4916 46.0407 49.5889 46.2829 49.4691C46.5251 49.3492 46.6225 49.0613 46.5026 48.8191C46.3828 48.5769 46.0948 48.4795 45.8526 48.5994Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0212 50.0109C42.7901 50.1252 42.6955 50.4052 42.8098 50.6363C42.9242 50.8673 43.2041 50.9619 43.4352 50.8476C43.6662 50.7333 43.7608 50.4533 43.6465 50.2223C43.5322 49.9912 43.2522 49.8966 43.0212 50.0109Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2019 51.441C39.9873 51.5472 39.8983 51.8105 40.0045 52.0252C40.1107 52.2399 40.374 52.3289 40.5887 52.2227C40.8034 52.1164 40.8923 51.8531 40.7861 51.6385C40.6799 51.4238 40.4166 51.3348 40.2019 51.441Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3693 52.8619C37.1602 52.9654 37.074 53.2205 37.1775 53.4296C37.2809 53.6388 37.536 53.725 37.7452 53.6215C37.9544 53.518 38.0406 53.263 37.9371 53.0538C37.8336 52.8446 37.5785 52.7584 37.3693 52.8619Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5452 54.2881C34.347 54.3861 34.2719 54.622 34.3672 54.8147C34.4625 55.0073 34.7011 55.088 34.8938 54.9927C35.0865 54.8973 35.1671 54.6587 35.0718 54.4661C34.9765 54.2734 34.7379 54.1928 34.5452 54.2881Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7167 55.7075C31.5313 55.7992 31.4553 56.0239 31.5471 56.2094C31.6388 56.3948 31.8635 56.4708 32.049 56.379C32.2344 56.2873 32.3104 56.0626 32.2186 55.8771C32.1269 55.6917 31.9022 55.6157 31.7167 55.7075Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8822 57.1244C28.7028 57.2132 28.6294 57.4305 28.7181 57.6099C28.8068 57.7892 29.0242 57.8627 29.2036 57.774C29.3829 57.6852 29.4564 57.4679 29.3676 57.2885C29.2789 57.1091 29.0615 57.0357 28.8822 57.1244Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0576 58.5477C25.887 58.6322 25.8174 58.8379 25.9019 59.0085C25.9863 59.1791 26.192 59.2487 26.3626 59.1642C26.5333 59.0798 26.6028 58.8741 26.5184 58.7035C26.434 58.5328 26.2283 58.4633 26.0576 58.5477Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2335 59.97C23.0793 60.0463 23.0154 60.2355 23.0916 60.3896C23.1679 60.5438 23.3571 60.6077 23.5113 60.5315C23.6654 60.4552 23.7293 60.266 23.6531 60.1118C23.5768 59.9577 23.3876 59.8938 23.2335 59.97Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4009 61.3948C20.2522 61.4683 20.1911 61.6494 20.2646 61.798C20.3381 61.9466 20.5191 62.0078 20.6678 61.9342C20.8164 61.8607 20.8776 61.6797 20.8041 61.5311C20.7305 61.3824 20.5495 61.3213 20.4009 61.3948Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5714 62.8044C17.4316 62.8736 17.3743 63.0431 17.4435 63.1829C17.5127 63.3227 17.6821 63.38 17.822 63.3108C17.9618 63.2416 18.0191 63.0722 17.9499 62.9323C17.8807 62.7925 17.7113 62.7352 17.5714 62.8044Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9747 29.4158C76.6224 29.5901 76.4778 30.018 76.6522 30.3703C76.8265 30.7226 77.2543 30.8672 77.6066 30.6929C77.9589 30.5186 78.1035 30.0907 77.9292 29.7384C77.7549 29.3861 77.327 29.2415 76.9747 29.4158Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1502 30.8372C73.8089 31.006 73.6671 31.4257 73.8359 31.7669C74.0048 32.1082 74.4244 32.2501 74.7657 32.0812C75.107 31.9123 75.2488 31.4927 75.0799 31.1514C74.9111 30.8101 74.4914 30.6683 74.1502 30.8372Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3178 32.2566C70.982 32.4227 70.8458 32.8259 71.0119 33.1616C71.178 33.4974 71.5812 33.6337 71.917 33.4676C72.2527 33.3014 72.389 32.8982 72.2229 32.5625C72.0567 32.2267 71.6536 32.0904 71.3178 32.2566Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4819 33.6569C68.1461 33.8231 68.0098 34.2263 68.1759 34.562C68.3421 34.8978 68.7453 35.0341 69.081 34.8679C69.4168 34.7018 69.5531 34.2986 69.3869 33.9629C69.2208 33.6271 68.8176 33.4908 68.4819 33.6569Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6604 35.0846C65.3412 35.2426 65.205 35.632 65.3656 35.9568C65.5263 36.2816 65.913 36.4123 66.2378 36.2516C66.5626 36.0909 66.6933 35.7042 66.5326 35.3794C66.3719 35.0547 65.9852 34.9239 65.6604 35.0846Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8261 36.506C62.5123 36.6612 62.3844 37.0397 62.5397 37.3535C62.6949 37.6672 63.0734 37.7951 63.3871 37.6399C63.7009 37.4847 63.8288 37.1062 63.6736 36.7924C63.5183 36.4787 63.1399 36.3507 62.8261 36.506Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0006 37.9254C59.6978 38.0752 59.5727 38.4454 59.7225 38.7482C59.8722 39.0509 60.2425 39.1761 60.5453 39.0263C60.848 38.8765 60.9731 38.5062 60.8234 38.2035C60.6736 37.9007 60.3033 37.7756 60.0006 37.9254Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1747 39.3598C56.8884 39.5015 56.7716 39.847 56.9133 40.1333C57.0549 40.4195 57.4004 40.5363 57.6867 40.3947C57.9729 40.2531 58.0897 39.9075 57.9481 39.6212C57.8065 39.335 57.4609 39.2182 57.1747 39.3598Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3472 40.7831C54.0664 40.922 53.9579 41.2567 54.0941 41.5319C54.2303 41.8071 54.5676 41.9211 54.8428 41.785C55.1181 41.6488 55.2321 41.3114 55.0959 41.0362C54.9597 40.761 54.6224 40.647 54.3472 40.7831Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5228 42.2049C51.2586 42.3357 51.1501 42.6566 51.2809 42.9208C51.4116 43.185 51.7325 43.2935 51.9967 43.1627C52.2609 43.032 52.3694 42.7111 52.2386 42.4469C52.1079 42.1827 51.787 42.0742 51.5228 42.2049Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.683 43.6092C48.4187 43.74 48.3103 44.0609 48.441 44.3251C48.5717 44.5893 48.8926 44.6978 49.1569 44.567C49.4211 44.4363 49.5295 44.1154 49.3988 43.8512C49.2681 43.587 48.9472 43.4785 48.683 43.6092Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8545 45.0306C45.5958 45.1586 45.4956 45.4685 45.6209 45.7217C45.7462 45.9749 46.0588 46.0806 46.312 45.9553C46.5652 45.8301 46.6709 45.5174 46.5456 45.2642C46.4204 45.011 46.1077 44.9053 45.8545 45.0306Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.028 46.4441C42.7803 46.5667 42.6802 46.8629 42.8027 47.1106C42.9253 47.3583 43.2215 47.4584 43.4692 47.3358C43.7169 47.2133 43.817 46.9171 43.6944 46.6694C43.5719 46.4217 43.2757 46.3216 43.028 46.4441Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1934 47.865C39.9567 47.9821 39.8539 48.2728 39.9737 48.515C40.0936 48.7572 40.3815 48.8545 40.6237 48.7347C40.8659 48.6149 40.9633 48.3269 40.8434 48.0847C40.7236 47.8425 40.4356 47.7452 40.1934 47.865Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3797 49.3082C37.165 49.4144 37.076 49.6777 37.1822 49.8924C37.2884 50.1071 37.5517 50.1961 37.7664 50.0899C37.9811 49.9836 38.0701 49.7203 37.9639 49.5057C37.8576 49.291 37.5943 49.202 37.3797 49.3082Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.55 50.7213C34.3408 50.8248 34.2546 51.0798 34.3581 51.289C34.4616 51.4982 34.7167 51.5844 34.9259 51.4809C35.135 51.3774 35.2212 51.1223 35.1177 50.9132C35.0142 50.704 34.7592 50.6178 34.55 50.7213Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7229 52.1553C31.5248 52.2533 31.4496 52.4892 31.5449 52.6819C31.6403 52.8745 31.8789 52.9552 32.0715 52.8599C32.2642 52.7645 32.3448 52.5259 32.2495 52.3333C32.1542 52.1406 31.9156 52.06 31.7229 52.1553Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8841 53.5576C28.6859 53.6557 28.6108 53.8916 28.7061 54.0842C28.8014 54.2769 29.04 54.3575 29.2327 54.2622C29.4253 54.1669 29.506 53.9283 29.4107 53.7356C29.3153 53.5429 29.0767 53.4623 28.8841 53.5576Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0605 54.9751C25.8733 55.0676 25.801 55.2953 25.8908 55.477C25.9807 55.6586 26.2111 55.7365 26.3927 55.6466C26.5744 55.5567 26.6523 55.3263 26.5624 55.1447C26.4725 54.963 26.2421 54.8852 26.0605 54.9751Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.225 56.3901C23.0488 56.4772 22.971 56.6939 23.0609 56.8755C23.1508 57.0572 23.3647 57.1295 23.5463 57.0396C23.728 56.9497 23.8003 56.7358 23.7104 56.5541C23.6205 56.3725 23.4066 56.3002 23.225 56.3901Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4112 57.8392C20.2571 57.9154 20.1931 58.1047 20.2694 58.2588C20.3456 58.4129 20.5349 58.4769 20.689 58.4006C20.8431 58.3244 20.9071 58.1351 20.8308 57.981C20.7546 57.8269 20.5653 57.7629 20.4112 57.8392Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5806 59.2542C17.4319 59.3277 17.3708 59.5087 17.4443 59.6573C17.5178 59.806 17.6989 59.8671 17.8475 59.7936C17.9961 59.7201 18.0573 59.5391 17.9837 59.3904C17.9102 59.2418 17.7292 59.1806 17.5806 59.2542Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7535 60.6804C14.6197 60.7465 14.5649 60.9086 14.6311 61.0424C14.6973 61.1762 14.8594 61.2309 14.9932 61.1648C15.1269 61.0986 15.1817 60.9365 15.1155 60.8027C15.0493 60.669 14.8872 60.6142 14.7535 60.6804Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9279 62.0997C11.8013 62.1624 11.754 62.316 11.8139 62.4371C11.8738 62.5582 12.0302 62.611 12.1513 62.5511C12.2724 62.4912 12.3252 62.3349 12.2653 62.2138C12.2054 62.0927 12.049 62.0398 11.9279 62.0997Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9825 25.851C76.6146 26.033 76.464 26.4787 76.646 26.8466C76.828 27.2144 77.2737 27.3651 77.6416 27.1831C78.0094 27.0011 78.1601 26.5553 77.9781 26.1875C77.7961 25.8196 77.3503 25.669 76.9825 25.851Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1532 27.2786C73.7975 27.4546 73.6519 27.8856 73.8279 28.2413C74.0038 28.597 74.4349 28.7427 74.7905 28.5667C75.1462 28.3907 75.2919 27.9597 75.1159 27.604C74.9399 27.2483 74.5089 27.1027 74.1532 27.2786Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3218 28.6922C70.9751 28.8638 70.8332 29.2834 71.0048 29.6302C71.1764 29.977 71.596 30.1188 71.9428 29.9472C72.2896 29.7756 72.4314 29.356 72.2598 29.0092C72.0883 28.6624 71.6686 28.5206 71.3218 28.6922Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4943 30.1116C68.1531 30.2804 68.0195 30.6891 68.1857 31.0249C68.3518 31.3606 68.7632 31.4997 69.099 31.3336C69.4347 31.1674 69.5738 30.756 69.4077 30.4203C69.2415 30.0845 68.8301 29.9454 68.4943 30.1116Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6627 31.5305C65.3325 31.6939 65.1962 32.0971 65.3596 32.4273C65.523 32.7576 65.9262 32.8939 66.2565 32.7305C66.5867 32.567 66.723 32.1639 66.5596 31.8336C66.3962 31.5033 65.993 31.3671 65.6627 31.5305Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8352 32.9499C62.513 33.1093 62.381 33.4998 62.5404 33.822C62.6999 34.1443 63.0904 34.2763 63.4126 34.1168C63.7349 33.9574 63.8668 33.5669 63.7074 33.2446C63.548 32.9224 63.1575 32.7904 62.8352 32.9499Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0077 34.3692C59.6946 34.5242 59.5664 34.9036 59.7213 35.2167C59.8762 35.5299 60.2557 35.6581 60.5688 35.5032C60.8819 35.3482 61.0101 34.9688 60.8552 34.6557C60.7003 34.3426 60.3209 34.2143 60.0077 34.3692Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1785 35.7969C56.8813 35.944 56.7534 36.3088 56.9032 36.6115C57.053 36.9142 57.415 37.0366 57.7177 36.8868C58.0205 36.737 58.1429 36.375 57.9931 36.0722C57.8433 35.7695 57.4812 35.6471 57.1785 35.7969Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.351 37.2124C54.0593 37.3568 53.9397 37.7106 54.084 38.0023C54.2284 38.294 54.5822 38.4136 54.8739 38.2693C55.1656 38.1249 55.2852 37.7711 55.1409 37.4794C54.9965 37.1876 54.6427 37.0681 54.351 37.2124Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5249 38.6484C51.2483 38.7852 51.1349 39.1205 51.2718 39.3971C51.4087 39.6738 51.7439 39.7871 52.0206 39.6502C52.2972 39.5133 52.4105 39.1781 52.2736 38.9014C52.1368 38.6248 51.8015 38.5115 51.5249 38.6484Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6952 40.0614C48.4255 40.1949 48.3143 40.524 48.4477 40.7937C48.5812 41.0634 48.9103 41.1747 49.18 41.0412C49.4497 40.9078 49.561 40.5786 49.4275 40.3089C49.2941 40.0392 48.965 39.928 48.6952 40.0614Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8687 41.4789C45.61 41.6069 45.4988 41.9222 45.6296 42.1865C45.7603 42.4507 46.0729 42.5564 46.3372 42.4256C46.6014 42.2949 46.7071 41.9822 46.5763 41.718C46.4456 41.4538 46.1329 41.3481 45.8687 41.4789Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0344 42.9002C42.7812 43.0255 42.6783 43.3299 42.8036 43.5831C42.9288 43.8363 43.2333 43.9392 43.4865 43.8139C43.7397 43.6887 43.8426 43.3842 43.7173 43.131C43.592 42.8778 43.2876 42.7749 43.0344 42.9002Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2088 44.3176C39.9666 44.4375 39.8665 44.7337 39.9864 44.9759C40.1062 45.2181 40.4024 45.3182 40.6446 45.1984C40.8868 45.0785 40.9869 44.7823 40.8671 44.5401C40.7472 44.2979 40.451 44.1978 40.2088 44.3176Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3825 45.7453C37.1515 45.8596 37.0569 46.1396 37.1712 46.3706C37.2855 46.6017 37.5655 46.6963 37.7965 46.582C38.0275 46.4677 38.1222 46.1877 38.0079 45.9567C37.8935 45.7256 37.6136 45.631 37.3825 45.7453Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5521 47.1647C34.3302 47.2745 34.2393 47.5434 34.3491 47.7653C34.4589 47.9873 34.7278 48.0782 34.9497 47.9683C35.1717 47.8585 35.2626 47.5896 35.1527 47.3677C35.0429 47.1458 34.774 47.0549 34.5521 47.1647Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7268 48.5865C31.5176 48.69 31.4314 48.9451 31.5349 49.1542C31.6384 49.3634 31.8934 49.4496 32.1026 49.3461C32.3118 49.2426 32.398 48.9876 32.2945 48.7784C32.191 48.5692 31.9359 48.483 31.7268 48.5865Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9012 50.0098C28.7031 50.1079 28.6169 50.3492 28.7177 50.5529C28.8185 50.7565 29.0571 50.8372 29.2607 50.7364C29.4644 50.6356 29.545 50.397 29.4443 50.1934C29.3435 49.9897 29.1049 49.909 28.9012 50.0098Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0659 51.4292C25.8744 51.524 25.7959 51.756 25.8907 51.9476C25.9855 52.1391 26.2176 52.2175 26.4091 52.1228C26.6006 52.028 26.679 51.7959 26.5843 51.6044C26.4895 51.4129 26.2574 51.3344 26.0659 51.4292Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2404 52.8525C23.058 52.9427 22.9833 53.1638 23.0735 53.3462C23.1638 53.5286 23.3848 53.6033 23.5672 53.513C23.7496 53.4228 23.8243 53.2017 23.7341 53.0193C23.6438 52.8369 23.4228 52.7622 23.2404 52.8525Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.417 54.2723C20.2463 54.3568 20.1768 54.5625 20.2613 54.7331C20.3457 54.9037 20.5514 54.9733 20.722 54.8888C20.8927 54.8044 20.9622 54.5987 20.8778 54.4281C20.7933 54.2574 20.5876 54.1879 20.417 54.2723Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.587 55.7044C17.4328 55.7807 17.3689 55.9699 17.4452 56.124C17.5214 56.2781 17.7106 56.3421 17.8648 56.2659C18.0189 56.1896 18.0829 56.0003 18.0066 55.8462C17.9303 55.6921 17.7411 55.6281 17.587 55.7044Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7602 57.1194C14.6116 57.1929 14.5504 57.374 14.624 57.5226C14.6975 57.6712 14.8785 57.7324 15.0271 57.6588C15.1758 57.5853 15.237 57.4043 15.1634 57.2557C15.0899 57.1071 14.9089 57.0459 14.7602 57.1194Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9328 58.5368C11.7929 58.606 11.7356 58.7755 11.8048 58.9153C11.874 59.0552 12.0435 59.1124 12.1833 59.0432C12.3232 58.9741 12.3804 58.8046 12.3112 58.6648C12.2421 58.5249 12.0726 58.4676 11.9328 58.5368Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0994 59.9601C8.96868 60.0248 8.91515 60.1832 8.97982 60.3139C9.0445 60.4447 9.2029 60.4982 9.33362 60.4335C9.46435 60.3688 9.51788 60.2104 9.4532 60.0797C9.38852 59.949 9.23012 59.8954 9.0994 59.9601Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9848 22.2929C76.6078 22.4794 76.4534 22.9362 76.6399 23.3132C76.8265 23.6902 77.2833 23.8445 77.6602 23.658C78.0372 23.4715 78.1916 23.0147 78.0051 22.6378C77.8185 22.2608 77.3618 22.1064 76.9848 22.2929Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1679 23.7357C73.8122 23.9117 73.6665 24.3427 73.8425 24.6984C74.0185 25.054 74.4495 25.1997 74.8052 25.0237C75.1609 24.8477 75.3066 24.4167 75.1306 24.0611C74.9546 23.7054 74.5236 23.5597 74.1679 23.7357Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3414 25.1551C70.9946 25.3266 70.8528 25.7463 71.0243 26.0931C71.1959 26.4398 71.6155 26.5817 71.9623 26.4101C72.3091 26.2385 72.4509 25.8189 72.2794 25.4721C72.1078 25.1253 71.6882 24.9835 71.3414 25.1551Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.509 26.5764C68.1677 26.7453 68.0342 27.1539 68.2003 27.4897C68.3664 27.8255 68.7778 27.9645 69.1136 27.7984C69.4494 27.6323 69.5884 27.2209 69.4223 26.8851C69.2562 26.5493 68.8448 26.4103 68.509 26.5764Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6721 27.9768C65.3308 28.1457 65.1973 28.5543 65.3634 28.8901C65.5295 29.2259 65.9409 29.3649 66.2767 29.1988C66.6125 29.0327 66.7515 28.6213 66.5854 28.2855C66.4193 27.9497 66.0079 27.8107 65.6721 27.9768Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8424 29.3899C62.511 29.5538 62.3753 29.9553 62.5393 30.2867C62.7032 30.6181 63.1048 30.7538 63.4361 30.5898C63.7675 30.4259 63.9032 30.0243 63.7393 29.693C63.5753 29.3616 63.1738 29.2259 62.8424 29.3899Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.01 30.8131C59.6878 30.9726 59.5558 31.3631 59.7152 31.6853C59.8747 32.0076 60.2652 32.1395 60.5874 31.9801C60.9097 31.8207 61.0416 31.4302 60.8822 31.1079C60.7228 30.7857 60.3323 30.6537 60.01 30.8131Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1835 32.2306C56.8704 32.3855 56.7421 32.7649 56.8971 33.0781C57.052 33.3912 57.4314 33.5194 57.7446 33.3645C58.0577 33.2096 58.1859 32.8301 58.031 32.517C57.8761 32.2039 57.4966 32.0757 57.1835 32.2306Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3647 33.6792C54.0729 33.8236 53.9533 34.1774 54.0977 34.4691C54.242 34.7608 54.5958 34.8804 54.8876 34.7361C55.1793 34.5917 55.2989 34.2379 55.1546 33.9462C55.0102 33.6544 54.6564 33.5349 54.3647 33.6792Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5405 35.1073C51.2639 35.2442 51.1506 35.5795 51.2874 35.8561C51.4243 36.1327 51.7596 36.246 52.0362 36.1092C52.3128 35.9723 52.4261 35.6371 52.2893 35.3604C52.1524 35.0838 51.8172 34.9705 51.5405 35.1073Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7109 36.5185C48.4403 36.6523 48.3295 36.9802 48.4634 37.2507C48.5972 37.5213 48.9251 37.6321 49.1956 37.4983C49.4662 37.3644 49.577 37.0365 49.4432 36.766C49.3093 36.4954 48.9814 36.3846 48.7109 36.5185Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8671 37.9227C45.5965 38.0566 45.4857 38.3845 45.6196 38.655C45.7535 38.9256 46.0813 39.0364 46.3519 38.9025C46.6225 38.7687 46.7333 38.4408 46.5994 38.1703C46.4655 37.8997 46.1377 37.7889 45.8671 37.9227Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0426 39.3402C42.7811 39.4695 42.674 39.7863 42.8034 40.0478C42.9327 40.3092 43.2496 40.4163 43.511 40.287C43.7724 40.1576 43.8795 39.8408 43.7502 39.5793C43.6208 39.3179 43.304 39.2108 43.0426 39.3402Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.215 40.7596C39.9618 40.8849 39.8589 41.1893 39.9842 41.4425C40.1095 41.6957 40.4139 41.7986 40.6671 41.6733C40.9204 41.548 41.0233 41.2436 40.898 40.9904C40.7727 40.7372 40.4683 40.6343 40.215 40.7596Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3836 42.179C37.1414 42.2988 37.0413 42.595 37.1612 42.8372C37.281 43.0794 37.5772 43.1795 37.8194 43.0597C38.0616 42.9398 38.1617 42.6436 38.0419 42.4014C37.922 42.1592 37.6258 42.0591 37.3836 42.179Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5668 43.6217C34.3448 43.7315 34.2539 44.0004 34.3637 44.2224C34.4735 44.4443 34.7425 44.5352 34.9644 44.4254C35.1863 44.3156 35.2772 44.0467 35.1674 43.8247C35.0576 43.6028 34.7887 43.5119 34.5668 43.6217Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7483 45.0513C31.5391 45.1548 31.4529 45.4099 31.5564 45.6191C31.6599 45.8282 31.9149 45.9145 32.1241 45.811C32.3333 45.7075 32.4195 45.4524 32.316 45.2432C32.2125 45.0341 31.9574 44.9478 31.7483 45.0513Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.91 46.4668C28.7094 46.5661 28.6272 46.8092 28.7265 47.0099C28.8257 47.2105 29.0689 47.2927 29.2695 47.1934C29.4702 47.0942 29.5523 46.851 29.4531 46.6504C29.3538 46.4497 29.1107 46.3676 28.91 46.4668Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.078 47.875C25.8798 47.9731 25.7937 48.2144 25.8944 48.4181C25.9952 48.6217 26.2338 48.7024 26.4375 48.6016C26.6411 48.5009 26.7218 48.2622 26.621 48.0586C26.5203 47.8549 26.2816 47.7743 26.078 47.875Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2456 49.2886C23.0529 49.3839 22.9751 49.6143 23.0704 49.8069C23.1657 49.9996 23.3961 50.0775 23.5888 49.9821C23.7814 49.8868 23.8593 49.6564 23.764 49.4638C23.6686 49.2711 23.4383 49.1932 23.2456 49.2886Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4142 50.7119C20.2318 50.8021 20.1571 51.0231 20.2473 51.2055C20.3376 51.3879 20.5586 51.4626 20.741 51.3724C20.9234 51.2821 20.9981 51.0611 20.9079 50.8787C20.8176 50.6963 20.5966 50.6216 20.4142 50.7119Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6046 52.1634C17.4504 52.2396 17.3865 52.4289 17.4627 52.583C17.539 52.7371 17.7282 52.8011 17.8824 52.7248C18.0365 52.6486 18.1004 52.4593 18.0242 52.3052C17.9479 52.1511 17.7587 52.0871 17.6046 52.1634Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7739 53.5745C14.625 53.6482 14.5639 53.8287 14.6377 53.9777C14.7114 54.1266 14.8919 54.1876 15.0408 54.1139C15.1898 54.0402 15.2508 53.8597 15.1771 53.7108C15.1034 53.5618 14.9229 53.5008 14.7739 53.5745Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9435 54.9997C11.8037 55.0689 11.7464 55.2384 11.8156 55.3782C11.8848 55.5181 12.0542 55.5753 12.1941 55.5061C12.3339 55.4369 12.3912 55.2675 12.322 55.1277C12.2528 54.9878 12.0833 54.9305 11.9435 54.9997Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.116 56.4152C8.98528 56.4799 8.93173 56.6383 8.99641 56.769C9.06109 56.8997 9.2195 56.9533 9.35022 56.8886C9.48095 56.8239 9.53448 56.6655 9.46981 56.5348C9.40513 56.4041 9.24672 56.3505 9.116 56.4152Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28005 57.8195C6.14794 57.8849 6.09511 58.0412 6.16047 58.1733C6.22584 58.3054 6.38216 58.3583 6.51427 58.2929C6.64638 58.2275 6.69923 58.0712 6.63387 57.9391C6.5685 57.807 6.41216 57.7541 6.28005 57.8195Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9961 18.747C76.6163 18.935 76.455 19.3985 76.6457 19.7838C76.8363 20.1691 77.2971 20.3248 77.6824 20.1342C78.0677 19.9435 78.2235 19.4828 78.0328 19.0974C77.8422 18.7121 77.3814 18.5564 76.9961 18.747Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1676 20.1625C73.7933 20.3477 73.6403 20.8003 73.8255 21.1746C74.0107 21.5489 74.4633 21.7018 74.8376 21.5166C75.2119 21.3314 75.3649 20.8789 75.1797 20.5046C74.9945 20.1303 74.5419 19.9773 74.1676 20.1625Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3384 21.5941C70.9766 21.7731 70.8284 22.2115 71.0074 22.5732C71.1864 22.935 71.6248 23.0832 71.9866 22.9042C72.3483 22.7252 72.4965 22.2868 72.3175 21.925C72.1385 21.5633 71.7001 21.4151 71.3384 21.5941Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5119 23.0076C68.1592 23.1821 68.0148 23.6094 68.1893 23.9621C68.3637 24.3147 68.7911 24.4592 69.1437 24.2847C69.4963 24.1102 69.6408 23.6829 69.4663 23.3302C69.2918 22.9776 68.8645 22.8332 68.5119 23.0076Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6853 24.429C65.3441 24.5978 65.2022 25.0175 65.3711 25.3587C65.5399 25.7 65.9596 25.8418 66.3008 25.673C66.6421 25.5041 66.784 25.0845 66.6151 24.7432C66.4462 24.4019 66.0266 24.2601 65.6853 24.429Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.851 25.8484C62.5152 26.0145 62.3789 26.4177 62.5451 26.7534C62.7112 27.0892 63.1144 27.2255 63.4502 27.0594C63.7859 26.8932 63.9222 26.49 63.7561 26.1543C63.5899 25.8185 63.1868 25.6822 62.851 25.8484Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0286 27.276C59.7063 27.4355 59.5744 27.826 59.7338 28.1482C59.8932 28.4704 60.2837 28.6024 60.606 28.443C60.9282 28.2835 61.0602 27.8931 60.9008 27.5708C60.7413 27.2486 60.3508 27.1166 60.0286 27.276Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2001 28.6954C56.887 28.8504 56.7588 29.2298 56.9137 29.5429C57.0686 29.856 57.448 29.9843 57.7612 29.8293C58.0743 29.6744 58.2025 29.295 58.0476 28.9819C57.8927 28.6687 57.5132 28.5405 57.2001 28.6954Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3697 30.1168C54.0657 30.2672 53.9412 30.6356 54.0916 30.9396C54.242 31.2436 54.6104 31.3681 54.9144 31.2177C55.2184 31.0672 55.3429 30.6989 55.1925 30.3949C55.0421 30.0909 54.6737 29.9663 54.3697 30.1168Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5412 31.5362C51.244 31.6832 51.1271 32.0425 51.2715 32.3343C51.4158 32.626 51.7778 32.7484 52.0696 32.604C52.3613 32.4597 52.4837 32.0976 52.3393 31.8059C52.195 31.5142 51.833 31.3918 51.5412 31.5362Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7079 32.9536C48.4216 33.0952 48.3048 33.4408 48.4464 33.727C48.5881 34.0133 48.9336 34.1301 49.2199 33.9884C49.5061 33.8468 49.6229 33.5012 49.4813 33.215C49.3397 32.9288 48.9941 32.812 48.7079 32.9536Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8813 34.3749C45.6006 34.5138 45.4921 34.8485 45.6283 35.1237C45.7644 35.3989 46.1018 35.5129 46.377 35.3767C46.6522 35.2406 46.7663 34.9032 46.6301 34.628C46.4939 34.3528 46.1566 34.2388 45.8813 34.3749Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.058 35.7987C42.7937 35.9294 42.6853 36.2503 42.816 36.5145C42.9467 36.7787 43.2676 36.8872 43.5318 36.7565C43.7961 36.6258 43.9045 36.3049 43.7738 36.0406C43.6431 35.7764 43.3222 35.668 43.058 35.7987Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2287 37.2225C39.9755 37.3478 39.8726 37.6522 39.9979 37.9054C40.1232 38.1586 40.4276 38.2615 40.6808 38.1362C40.934 38.0109 41.0369 37.7065 40.9116 37.4533C40.7864 37.2001 40.4819 37.0972 40.2287 37.2225Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4002 38.6419C37.157 38.7622 37.0574 39.0569 37.1778 39.3001C37.2981 39.5433 37.5928 39.6429 37.836 39.5226C38.0792 39.4022 38.1788 39.1075 38.0585 38.8643C37.9382 38.6211 37.6435 38.5215 37.4002 38.6419Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5737 40.0632C34.3396 40.179 34.2438 40.4627 34.3596 40.6967C34.4754 40.9308 34.7591 41.0267 34.9931 40.9109C35.2272 40.7951 35.3231 40.5114 35.2073 40.2773C35.0915 40.0432 34.8078 39.9474 34.5737 40.0632Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7404 41.4845C31.5154 41.5958 31.4233 41.8684 31.5346 42.0934C31.6459 42.3184 31.9185 42.4105 32.1434 42.2992C32.3684 42.1879 32.4605 41.9153 32.3492 41.6903C32.2379 41.4654 31.9653 41.3732 31.7404 41.4845Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9148 42.9039C28.7002 43.0101 28.6112 43.2734 28.7174 43.4881C28.8236 43.7028 29.0869 43.7918 29.3016 43.6856C29.5162 43.5793 29.6052 43.316 29.499 43.1014C29.3928 42.8867 29.1295 42.7977 28.9148 42.9039Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0905 44.3238C25.8868 44.4245 25.8034 44.6714 25.9041 44.875C26.0049 45.0787 26.2518 45.1622 26.4554 45.0614C26.6591 44.9606 26.7425 44.7138 26.6417 44.5101C26.541 44.3064 26.2941 44.223 26.0905 44.3238Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2561 45.749C23.0616 45.8453 22.9819 46.0811 23.0782 46.2756C23.1744 46.4702 23.4102 46.5499 23.6048 46.4536C23.7993 46.3573 23.879 46.1216 23.7827 45.927C23.6865 45.7324 23.4507 45.6528 23.2561 45.749Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4328 47.1728C20.2504 47.263 20.1757 47.4841 20.2659 47.6665C20.3562 47.8489 20.5772 47.9236 20.7596 47.8333C20.942 47.7431 21.0167 47.5221 20.9264 47.3396C20.8362 47.1572 20.6152 47.0825 20.4328 47.1728Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6082 48.5922C17.4349 48.6779 17.3639 48.8879 17.4497 49.0612C17.5354 49.2345 17.7454 49.3054 17.9187 49.2197C18.0919 49.134 18.1629 48.924 18.0772 48.7507C17.9914 48.5774 17.7815 48.5064 17.6082 48.5922Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.777 50.0179C14.6173 50.0969 14.5506 50.2944 14.6296 50.454C14.7086 50.6136 14.906 50.6804 15.0657 50.6014C15.2253 50.5224 15.2921 50.3249 15.2131 50.1653C15.1341 50.0057 14.9366 49.9389 14.777 50.0179Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9475 51.4373C11.7934 51.5135 11.7322 51.6946 11.8085 51.8487C11.8848 52.0028 12.0658 52.064 12.2199 51.9877C12.374 51.9115 12.4352 51.7305 12.3589 51.5763C12.2827 51.4222 12.1017 51.361 11.9475 51.4373Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.122 52.8567C8.97911 52.9274 8.92059 53.1005 8.99129 53.2434C9.06198 53.3863 9.23512 53.4448 9.37801 53.3741C9.52089 53.3034 9.57941 53.1303 9.50871 52.9874C9.43802 52.8445 9.26488 52.786 9.122 52.8567Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2906 54.278C6.15683 54.3442 6.10204 54.5063 6.16823 54.64C6.23441 54.7738 6.3965 54.8286 6.53026 54.7624C6.66402 54.6962 6.71881 54.5341 6.65263 54.4004C6.58644 54.2666 6.42436 54.2118 6.2906 54.278Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0009 15.1783C76.6027 15.3753 76.4395 15.8579 76.6366 16.2561C76.8336 16.6544 77.3162 16.8175 77.7145 16.6205C78.1127 16.4234 78.2758 15.9408 78.0788 15.5426C77.8817 15.1443 77.3991 14.9812 77.0009 15.1783Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1654 16.5972C73.7746 16.7906 73.6133 17.2678 73.8066 17.6586C74 18.0494 74.4772 18.2107 74.868 18.0173C75.2589 17.824 75.4202 17.3468 75.2268 16.9559C75.0334 16.5651 74.5562 16.4038 74.1654 16.5972Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3506 18.0443C70.9828 18.2263 70.8321 18.6721 71.0141 19.0399C71.1961 19.4078 71.6419 19.5584 72.0097 19.3764C72.3776 19.1944 72.5282 18.7487 72.3462 18.3808C72.1642 18.013 71.7185 17.8623 71.3506 18.0443Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5239 19.4574C68.1661 19.6344 68.0132 20.0732 68.193 20.4365C68.3727 20.7998 68.8088 20.9472 69.1721 20.7675C69.5354 20.5877 69.6828 20.1516 69.503 19.7883C69.3233 19.425 68.8872 19.2776 68.5239 19.4574Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6896 20.8787C65.3373 21.053 65.1927 21.4809 65.367 21.8332C65.5413 22.1855 65.9691 22.3301 66.3214 22.1558C66.6737 21.9815 66.8183 21.5536 66.644 21.2013C66.4697 20.849 66.0419 20.7044 65.6896 20.8787Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8556 22.2811C62.5033 22.4554 62.3587 22.8832 62.533 23.2355C62.7073 23.5878 63.1352 23.7324 63.4875 23.5581C63.8397 23.3838 63.9844 22.956 63.81 22.6037C63.6357 22.2514 63.2079 22.1068 62.8556 22.2811Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0291 23.6985C59.6878 23.8674 59.546 24.287 59.7148 24.6283C59.8837 24.9695 60.3033 25.1114 60.6446 24.9425C60.9859 24.7737 61.1277 24.354 60.9588 24.0128C60.79 23.6715 60.3704 23.5296 60.0291 23.6985Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1928 25.1159C56.857 25.2821 56.7208 25.6852 56.8869 26.021C57.053 26.3568 57.4562 26.4931 57.792 26.3269C58.1277 26.1608 58.264 25.7576 58.0979 25.4218C57.9317 25.0861 57.5286 24.9498 57.1928 25.1159Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3704 26.5456C54.0481 26.705 53.9162 27.0955 54.0756 27.4177C54.235 27.74 54.6255 27.872 54.9478 27.7125C55.27 27.5531 55.402 27.1626 55.2426 26.8404C55.0831 26.5181 54.6926 26.3861 54.3704 26.5456Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5506 27.9903C51.2533 28.1374 51.1255 28.5021 51.2752 28.8049C51.425 29.1076 51.7871 29.23 52.0898 29.0802C52.3926 28.9304 52.5149 28.5683 52.3651 28.2656C52.2153 27.9629 51.8533 27.8405 51.5506 27.9903Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7231 29.4058C48.4313 29.5501 48.3117 29.9039 48.4561 30.1957C48.6004 30.4874 48.9542 30.607 49.246 30.4626C49.5377 30.3183 49.6573 29.9645 49.513 29.6727C49.3686 29.381 49.0148 29.2614 48.7231 29.4058Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8956 30.8271C45.6129 30.967 45.4971 31.3096 45.6369 31.5923C45.7768 31.875 46.1194 31.9908 46.4021 31.8509C46.6849 31.7111 46.8007 31.3685 46.6608 31.0857C46.5209 30.803 46.1783 30.6872 45.8956 30.8271Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0548 32.2314C42.772 32.3713 42.6562 32.7139 42.7961 32.9966C42.936 33.2793 43.2786 33.3951 43.5613 33.2552C43.8441 33.1154 43.9598 32.7728 43.82 32.49C43.6801 32.2073 43.3375 32.0915 43.0548 32.2314Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2273 33.6488C39.9537 33.7842 39.8416 34.1158 39.977 34.3894C40.1123 34.663 40.4439 34.775 40.7175 34.6396C40.9911 34.5043 41.1032 34.1727 40.9678 33.8991C40.8324 33.6255 40.5009 33.5135 40.2273 33.6488Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3968 35.0643C37.1326 35.195 37.0242 35.5159 37.1549 35.7802C37.2856 36.0444 37.6065 36.1528 37.8707 36.0221C38.1349 35.8914 38.2434 35.5705 38.1127 35.3063C37.9819 35.0421 37.661 34.9336 37.3968 35.0643Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5715 36.4939C34.3183 36.6192 34.2154 36.9237 34.3407 37.1769C34.4659 37.4301 34.7704 37.533 35.0236 37.4077C35.2768 37.2824 35.3797 36.978 35.2544 36.7248C35.1291 36.4716 34.8247 36.3687 34.5715 36.4939Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7546 37.9348C31.5236 38.0491 31.4289 38.329 31.5433 38.5601C31.6576 38.7911 31.9375 38.8858 32.1686 38.7714C32.3996 38.6571 32.4942 38.3772 32.3799 38.1461C32.2656 37.9151 31.9856 37.8204 31.7546 37.9348Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9281 39.3541C28.7062 39.464 28.6153 39.7329 28.7251 39.9548C28.8349 40.1767 29.1038 40.2676 29.3257 40.1578C29.5476 40.048 29.6385 39.7791 29.5287 39.5572C29.4189 39.3352 29.15 39.2443 28.9281 39.3541Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0979 40.7799C25.8887 40.8834 25.8025 41.1384 25.906 41.3476C26.0095 41.5568 26.2645 41.643 26.4737 41.5395C26.6829 41.436 26.7691 41.1809 26.6656 40.9718C26.5621 40.7626 26.307 40.6764 26.0979 40.7799Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2629 42.1822C23.0537 42.2857 22.9675 42.5408 23.071 42.7499C23.1745 42.9591 23.4296 43.0453 23.6387 42.9418C23.8479 42.8383 23.9341 42.5833 23.8306 42.3741C23.7271 42.1649 23.4721 42.0787 23.2629 42.1822Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4354 43.6055C20.2372 43.7035 20.1511 43.9449 20.2519 44.1486C20.3526 44.3522 20.5912 44.4329 20.7949 44.3321C20.9986 44.2313 21.0792 43.9927 20.9785 43.789C20.8777 43.5854 20.6391 43.5047 20.4354 43.6055Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.603 45.0229C17.4104 45.1183 17.3325 45.3486 17.4278 45.5413C17.5231 45.734 17.7535 45.8118 17.9462 45.7165C18.1388 45.6212 18.2167 45.3908 18.1214 45.1981C18.0261 45.0055 17.7957 44.9276 17.603 45.0229Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7852 46.4618C14.6145 46.5462 14.545 46.7519 14.6294 46.9226C14.7138 47.0932 14.9195 47.1627 15.0902 47.0783C15.2608 46.9939 15.3304 46.7882 15.2459 46.6175C15.1615 46.4469 14.9558 46.3774 14.7852 46.4618Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.961 47.8899C11.8069 47.9662 11.7429 48.1554 11.8192 48.3096C11.8954 48.4637 12.0847 48.5277 12.2388 48.4514C12.3929 48.3751 12.4569 48.1859 12.3806 48.0318C12.3044 47.8776 12.1151 47.8137 11.961 47.8899Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12939 49.3088C8.98077 49.3824 8.9196 49.5634 8.99313 49.712C9.06667 49.8606 9.24768 49.9218 9.3963 49.8483C9.54492 49.7748 9.6061 49.5937 9.53256 49.4451C9.45903 49.2965 9.27801 49.2353 9.12939 49.3088Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30385 50.7282C6.16401 50.7974 6.10672 50.9669 6.17591 51.1067C6.2451 51.2466 6.41457 51.3038 6.55442 51.2347C6.69426 51.1655 6.75152 50.996 6.68233 50.8562C6.61314 50.7163 6.44369 50.659 6.30385 50.7282Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46789 52.1286C3.33028 52.1967 3.26916 52.364 3.33998 52.5071C3.41079 52.6502 3.57534 52.7059 3.71846 52.6351C3.86158 52.5642 3.91721 52.3997 3.8464 52.2566C3.77558 52.1134 3.61101 52.0578 3.46789 52.1286Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0044 11.6285C76.6026 11.8273 76.4357 12.321 76.6345 12.7228C76.8333 13.1247 77.3215 13.2942 77.7288 13.0927C78.1362 12.8912 78.2975 12.4002 78.0987 11.9984C77.8999 11.5965 77.4117 11.427 77.0044 11.6285Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1788 13.0479C73.7825 13.244 73.6212 13.7212 73.8173 14.1175C74.0134 14.5138 74.4906 14.6751 74.887 14.4791C75.2833 14.283 75.4446 13.8057 75.2485 13.4094C75.0524 13.0131 74.5752 12.8518 74.1788 13.0479Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3513 14.4673C70.966 14.6579 70.8075 15.1269 70.9982 15.5122C71.1888 15.8975 71.6578 16.0561 72.0431 15.8654C72.4284 15.6748 72.5869 15.2058 72.3963 14.8205C72.2057 14.4351 71.7367 14.2766 71.3513 14.4673Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.517 15.8867C68.1372 16.0746 67.987 16.5326 68.1722 16.9069C68.3574 17.2812 68.8181 17.437 69.1924 17.2518C69.5667 17.0666 69.7225 16.6058 69.5373 16.2315C69.3521 15.8572 68.8913 15.7015 68.517 15.8867Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6915 17.3061C65.3227 17.4885 65.1725 17.9328 65.355 18.3016C65.5374 18.6704 65.9818 18.8206 66.3506 18.6381C66.7194 18.4557 66.8695 18.0113 66.6871 17.6425C66.5046 17.2737 66.0603 17.1236 65.6915 17.3061Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8671 18.7337C62.5093 18.9108 62.3647 19.3386 62.5417 19.6964C62.7188 20.0542 63.1466 20.1988 63.5044 20.0218C63.8622 19.8447 64.0068 19.4169 63.8298 19.0591C63.6528 18.7013 63.2249 18.5567 62.8671 18.7337Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0369 20.1594C59.6956 20.3283 59.5538 20.7479 59.7226 21.0892C59.8915 21.4305 60.3111 21.5723 60.6524 21.4035C60.9937 21.2346 61.1355 20.815 60.9667 20.4737C60.7978 20.1324 60.3782 19.9906 60.0369 20.1594Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2114 21.5788C56.8756 21.745 56.7393 22.1481 56.9054 22.4839C57.0716 22.8197 57.4748 22.956 57.8105 22.7898C58.1463 22.6237 58.2826 22.2205 58.1164 21.8847C57.9503 21.549 57.5471 21.4127 57.2114 21.5788Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3838 22.9943C54.0591 23.155 53.9256 23.5499 54.0863 23.8747C54.247 24.1995 54.6419 24.333 54.9667 24.1723C55.2914 24.0116 55.4249 23.6166 55.2642 23.2919C55.1036 22.9671 54.7086 22.8336 54.3838 22.9943Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5505 24.4176C51.2343 24.574 51.1048 24.9572 51.2613 25.2733C51.4177 25.5895 51.8008 25.719 52.117 25.5625C52.4331 25.4061 52.5626 25.023 52.4062 24.7068C52.2498 24.3907 51.8667 24.2612 51.5505 24.4176Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7259 25.835C48.4177 25.9876 48.2925 26.3578 48.4451 26.6661C48.5976 26.9743 48.9678 27.0995 49.2761 26.9469C49.5843 26.7944 49.7095 26.4242 49.557 26.1159C49.4044 25.8077 49.0342 25.6825 48.7259 25.835Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8938 27.2627C45.5965 27.4098 45.4797 27.7691 45.624 28.0608C45.7683 28.3526 46.1249 28.4777 46.4221 28.3306C46.7194 28.1835 46.8362 27.8242 46.6919 27.5325C46.5475 27.2407 46.1855 27.1184 45.8938 27.2627Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0663 28.6801C42.78 28.8218 42.6632 29.1673 42.8048 29.4536C42.9465 29.7398 43.292 29.8566 43.5783 29.715C43.8645 29.5734 43.9813 29.2278 43.8397 28.9416C43.6981 28.6553 43.3525 28.5385 43.0663 28.6801Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2388 30.0995C39.958 30.2384 39.8495 30.5731 39.9857 30.8483C40.1219 31.1235 40.4592 31.2375 40.7344 31.1014C41.0097 30.9652 41.1237 30.6278 40.9875 30.3526C40.8513 30.0774 40.514 29.9634 40.2388 30.0995Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4095 31.5253C37.1453 31.656 37.0368 31.9769 37.1676 32.2411C37.2983 32.5053 37.6192 32.6138 37.8834 32.483C38.1476 32.3523 38.2561 32.0314 38.1254 31.7672C37.9946 31.503 37.6737 31.3945 37.4095 31.5253Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5842 32.9471C34.331 33.0724 34.2281 33.3768 34.3534 33.63C34.4786 33.8832 34.7831 33.9861 35.0363 33.8608C35.2895 33.7355 35.3924 33.4311 35.2671 33.1779C35.1418 32.9247 34.8374 32.8218 34.5842 32.9471Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7596 34.3684C31.5174 34.4882 31.4173 34.7845 31.5371 35.0267C31.657 35.2689 31.9532 35.369 32.1954 35.2491C32.4376 35.1293 32.5377 34.8331 32.4179 34.5909C32.298 34.3487 32.0018 34.2486 31.7596 34.3684Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9282 35.7917C28.6915 35.9088 28.5997 36.1941 28.7141 36.4253C28.8285 36.6565 29.1164 36.7538 29.3476 36.6394C29.5788 36.525 29.6762 36.237 29.5618 36.0058C29.4474 35.7747 29.1594 35.6773 28.9282 35.7917Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1007 37.213C25.875 37.3247 25.7833 37.5962 25.8949 37.8219C26.0066 38.0476 26.2781 38.1394 26.5038 38.0277C26.7295 37.916 26.8213 37.6445 26.7096 37.4188C26.5979 37.1932 26.3264 37.1014 26.1007 37.213Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2754 38.6329C23.0607 38.7391 22.9745 38.9942 23.0807 39.2089C23.1869 39.4235 23.442 39.5098 23.6567 39.4035C23.8714 39.2973 23.9576 39.0423 23.8513 38.8276C23.7451 38.6129 23.4901 38.5267 23.2754 38.6329Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4411 40.0542C20.2374 40.155 20.154 40.4019 20.2547 40.6055C20.3555 40.8092 20.6023 40.8926 20.806 40.7918C21.0097 40.6911 21.0931 40.4442 20.9923 40.2406C20.8916 40.0369 20.6447 39.9535 20.4411 40.0542Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6145 41.4756C17.4164 41.5736 17.3412 41.8095 17.4366 42.0022C17.5319 42.1948 17.7705 42.2755 17.9632 42.1802C18.1558 42.0848 18.2364 41.8462 18.1411 41.6536C18.0458 41.4609 17.8072 41.3803 17.6145 41.4756Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7911 42.8994C14.6087 42.9896 14.5341 43.2106 14.6243 43.393C14.7145 43.5754 14.9356 43.6501 15.118 43.5599C15.3004 43.4696 15.3751 43.2486 15.2848 43.0662C15.1946 42.8838 14.9736 42.8091 14.7911 42.8994Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9638 44.3329C11.7932 44.4173 11.7237 44.623 11.8081 44.7937C11.8925 44.9643 12.0982 45.0338 12.2689 44.9494C12.4395 44.865 12.5091 44.6593 12.4246 44.4886C12.3402 44.318 12.1345 44.2485 11.9638 44.3329Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13246 45.7406C8.97283 45.8195 8.90609 46.017 8.98507 46.1766C9.06405 46.3363 9.26152 46.403 9.42115 46.324C9.58078 46.2451 9.64753 46.0476 9.56854 45.8879C9.48956 45.7283 9.29209 45.6616 9.13246 45.7406Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30789 47.1619C6.15377 47.2382 6.09259 47.4192 6.16884 47.5733C6.2451 47.7274 6.42612 47.7886 6.58024 47.7123C6.73437 47.6361 6.79555 47.4551 6.71929 47.3009C6.64303 47.1468 6.46202 47.0856 6.30789 47.1619Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47258 48.5852C3.32946 48.656 3.27106 48.8288 3.34188 48.9719C3.41269 49.115 3.58548 49.1734 3.72859 49.1026C3.87171 49.0318 3.93011 48.859 3.8593 48.7159C3.78849 48.5728 3.6157 48.5144 3.47258 48.5852Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0165 8.07435C76.603 8.27891 76.4337 8.77991 76.6382 9.19336C76.8428 9.6068 77.3438 9.77614 77.7572 9.57157C78.1707 9.367 78.34 8.86601 78.1355 8.45256C77.9309 8.03911 77.4299 7.86978 77.0165 8.07435Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.189 9.49568C73.7871 9.6945 73.6203 10.1882 73.8191 10.59C74.0179 10.9918 74.5116 11.1587 74.9134 10.9599C75.3152 10.7611 75.4848 10.2729 75.2833 9.86556C75.0817 9.45822 74.5963 9.29414 74.189 9.49568Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3556 10.917C70.9593 11.1131 70.798 11.5903 70.9941 11.9867C71.1902 12.383 71.6674 12.5443 72.0637 12.3482C72.46 12.1521 72.6213 11.6749 72.4252 11.2786C72.2291 10.8822 71.7519 10.7209 71.3556 10.917Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5375 12.3515C68.1577 12.5394 68.0075 12.9975 68.1927 13.3718C68.3779 13.7461 68.8386 13.9018 69.2129 13.7166C69.5873 13.5314 69.743 13.0707 69.5578 12.6964C69.3726 12.322 68.9118 12.1663 68.5375 12.3515Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.71 13.7709C65.3412 13.9534 65.191 14.3977 65.3735 14.7665C65.556 15.1353 66.0003 15.2855 66.3691 15.103C66.7379 14.9205 66.8881 14.4762 66.7056 14.1074C66.5231 13.7386 66.0788 13.5884 65.71 13.7709Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8798 15.1966C62.522 15.3736 62.3774 15.8015 62.5544 16.1593C62.7315 16.5171 63.1593 16.6617 63.5171 16.4847C63.8749 16.3076 64.0195 15.8798 63.8425 15.522C63.6655 15.1642 63.2376 15.0196 62.8798 15.1966Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0448 16.597C59.6871 16.774 59.5424 17.2019 59.7195 17.5597C59.8965 17.9175 60.3244 18.0621 60.6821 17.8851C61.0399 17.708 61.1845 17.2802 61.0075 16.9224C60.8305 16.5646 60.4026 16.42 60.0448 16.597Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2195 18.0247C56.8782 18.1935 56.7364 18.6132 56.9053 18.9544C57.0741 19.2957 57.4937 19.4376 57.835 19.2687C58.1763 19.0998 58.3181 18.6802 58.1493 18.3389C57.9804 17.9976 57.5608 17.8558 57.2195 18.0247Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3891 19.4441C54.0533 19.6102 53.917 20.0134 54.0832 20.3492C54.2493 20.6849 54.6525 20.8212 54.9883 20.6551C55.324 20.4889 55.4603 20.0858 55.2942 19.75C55.128 19.4142 54.7249 19.2779 54.3891 19.4441Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5606 20.8615C51.2358 21.0222 51.1024 21.4171 51.263 21.7419C51.4237 22.0667 51.8187 22.2002 52.1434 22.0395C52.4682 21.8788 52.6017 21.4838 52.441 21.1591C52.2803 20.8343 51.8854 20.7008 51.5606 20.8615Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7357 22.2999C48.4274 22.4524 48.3023 22.8227 48.4548 23.1309C48.6073 23.4392 48.9776 23.5643 49.2858 23.4118C49.5941 23.2593 49.7192 22.889 49.5667 22.5808C49.4142 22.2725 49.0439 22.1474 48.7357 22.2999Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9123 23.7256C45.6151 23.8727 45.4982 24.232 45.6426 24.5237C45.7869 24.8155 46.1489 24.9378 46.4407 24.7935C46.7324 24.6491 46.8548 24.2871 46.7104 23.9954C46.5661 23.7036 46.2096 23.5785 45.9123 23.7256Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0858 25.1411C42.7996 25.2827 42.6828 25.6283 42.8244 25.9145C42.966 26.2008 43.3116 26.3176 43.5978 26.1759C43.884 26.0343 44.0008 25.6887 43.8592 25.4025C43.7176 25.1163 43.372 24.9995 43.0858 25.1411Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.244 26.5473C39.9578 26.689 39.841 27.0345 39.9826 27.3208C40.1242 27.607 40.4698 27.7238 40.756 27.5822C41.0422 27.4406 41.159 27.095 41.0174 26.8087C40.8758 26.5225 40.5302 26.4057 40.244 26.5473Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4165 27.9667C37.1358 28.1056 37.0273 28.4402 37.1634 28.7155C37.2996 28.9907 37.637 29.1047 37.9122 28.9685C38.1874 28.8324 38.3014 28.495 38.1652 28.2198C38.0291 27.9446 37.6917 27.8305 37.4165 27.9667Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5941 29.3924C34.3299 29.5232 34.2214 29.8441 34.3522 30.1083C34.4829 30.3725 34.8038 30.481 35.068 30.3502C35.3322 30.2195 35.4407 29.8986 35.3099 29.6344C35.1792 29.3702 34.8583 29.2617 34.5941 29.3924Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7629 30.8182C31.5097 30.9434 31.4068 31.2479 31.5321 31.5011C31.6574 31.7543 31.9618 31.8572 32.215 31.7319C32.4682 31.6066 32.5711 31.3022 32.4458 31.049C32.3205 30.7958 32.0161 30.6929 31.7629 30.8182Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9438 32.2565C28.7071 32.3737 28.6153 32.6589 28.7297 32.8901C28.8441 33.1213 29.1321 33.2186 29.3633 33.1042C29.5944 32.9899 29.6918 32.7019 29.5774 32.4707C29.463 32.2395 29.175 32.1422 28.9438 32.2565Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1173 33.672C25.8924 33.7833 25.8002 34.0559 25.9115 34.2809C26.0228 34.5059 26.2954 34.598 26.5204 34.4867C26.7454 34.3754 26.8375 34.1028 26.7262 33.8778C26.6149 33.6529 26.3423 33.5607 26.1173 33.672Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2861 35.1017C23.0715 35.2079 22.9852 35.4629 23.0915 35.6776C23.1977 35.8923 23.4527 35.9785 23.6674 35.8723C23.8821 35.7661 23.9683 35.511 23.8621 35.2963C23.7559 35.0817 23.5008 34.9954 23.2861 35.1017Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4512 36.5021C20.2365 36.6083 20.1503 36.8633 20.2565 37.078C20.3627 37.2927 20.6178 37.3789 20.8325 37.2727C21.0471 37.1665 21.1333 36.9114 21.0271 36.6967C20.9209 36.482 20.6658 36.3958 20.4512 36.5021Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6246 37.9195C17.421 38.0203 17.3375 38.2671 17.4383 38.4708C17.5391 38.6744 17.7859 38.7579 17.9896 38.6571C18.1933 38.5563 18.2767 38.3095 18.1759 38.1058C18.0752 37.9021 17.8283 37.8187 17.6246 37.9195Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7932 39.3408C14.5951 39.4389 14.5199 39.6748 14.6153 39.8674C14.7106 40.0601 14.9492 40.1407 15.1418 40.0454C15.3345 39.9501 15.4152 39.7115 15.3198 39.5188C15.2245 39.3261 14.9859 39.2455 14.7932 39.3408Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9785 40.7899C11.8079 40.8744 11.7384 41.08 11.8228 41.2507C11.9072 41.4213 12.1129 41.4909 12.2835 41.4064C12.4542 41.322 12.5237 41.1163 12.4393 40.9457C12.3549 40.775 12.1492 40.7055 11.9785 40.7899Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15102 42.2054C8.99139 42.2844 8.92464 42.4819 9.00362 42.6415C9.08261 42.8011 9.28008 42.8679 9.43971 42.7889C9.59934 42.7099 9.66608 42.5124 9.5871 42.3528C9.50812 42.1932 9.31065 42.1264 9.15102 42.2054Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.31961 43.6287C6.16549 43.705 6.1043 43.886 6.18056 44.0401C6.25682 44.1942 6.43784 44.2554 6.59196 44.1791C6.74609 44.1029 6.80727 43.9219 6.73101 43.7677C6.65475 43.6136 6.47374 43.5524 6.31961 43.6287Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49309 45.0481C3.34997 45.1189 3.29157 45.2917 3.36238 45.4348C3.43319 45.5779 3.60598 45.6363 3.7491 45.5655C3.89222 45.4947 3.95062 45.3219 3.87981 45.1788C3.809 45.0357 3.63621 44.9773 3.49309 45.0481Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.656176 46.4485C0.513059 46.5193 0.454658 46.6921 0.525469 46.8352C0.59628 46.9783 0.76907 47.0367 0.912186 46.9659C1.0553 46.8951 1.1137 46.7223 1.04289 46.5792C0.972082 46.4361 0.799292 46.3777 0.656176 46.4485Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0256 4.52019C76.603 4.72927 76.43 5.24132 76.639 5.66389C76.8481 6.08645 77.3602 6.25952 77.7827 6.05044C78.2053 5.84137 78.3784 5.32932 78.1693 4.90675C77.9602 4.48418 77.4482 4.31112 77.0256 4.52019Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1932 5.93958C73.7798 6.14415 73.6104 6.64514 73.815 7.05859C74.0196 7.47204 74.5206 7.64137 74.934 7.4368C75.3475 7.23224 75.5168 6.73124 75.3122 6.31779C75.1077 5.90435 74.6067 5.73502 74.1932 5.93958Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3667 7.36288C70.9649 7.5617 70.798 8.05537 70.9968 8.4572C71.1956 8.85903 71.6893 9.02589 72.0911 8.82707C72.493 8.62826 72.6626 8.14008 72.461 7.73274C72.2595 7.32541 71.7685 7.16407 71.3667 7.36288Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5402 8.78227C68.1438 8.97836 67.9825 9.45558 68.1786 9.8519C68.3747 10.2482 68.852 10.4095 69.2483 10.2134C69.6446 10.0173 69.8059 9.54011 69.6098 9.14379C69.4137 8.74747 68.9365 8.58618 68.5402 8.78227Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.708 10.206C65.3282 10.394 65.1669 10.8574 65.3576 11.2428C65.5482 11.6281 66.009 11.7838 66.3943 11.5932C66.7796 11.4025 66.9354 10.9417 66.7447 10.5564C66.5541 10.1711 66.0933 10.0154 65.708 10.206Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8815 11.6254C62.5076 11.8104 62.3544 12.2635 62.5394 12.6375C62.7244 13.0114 63.1775 13.1645 63.5515 12.9795C63.9254 12.7945 64.0785 12.3414 63.8935 11.9675C63.7085 11.5935 63.2554 11.4404 62.8815 11.6254Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.053 13.0428C59.6882 13.2233 59.5388 13.6654 59.7193 14.0302C59.8998 14.395 60.3418 14.5444 60.7066 14.3639C61.0715 14.1834 61.2209 13.7414 61.0404 13.3766C60.8599 13.0118 60.4178 12.8623 60.053 13.0428Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2197 14.4603C56.8619 14.6373 56.7172 15.0652 56.8943 15.423C57.0713 15.7808 57.4992 15.9254 57.857 15.7483C58.2147 15.5713 58.3594 15.1435 58.1823 14.7857C58.0053 14.4279 57.5774 14.2833 57.2197 14.4603Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3982 15.8919C54.0569 16.0607 53.9151 16.4803 54.084 16.8216C54.2528 17.1629 54.6725 17.3047 55.0137 17.1359C55.355 16.967 55.4968 16.5474 55.328 16.2061C55.1591 15.8648 54.7395 15.723 54.3982 15.8919Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5707 17.3074C51.2349 17.4735 51.0987 17.8767 51.2648 18.2124C51.4309 18.5482 51.8341 18.6845 52.1699 18.5183C52.5057 18.3522 52.6419 17.949 52.4758 17.6133C52.3097 17.2775 51.9065 17.1412 51.5707 17.3074Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7405 18.735C48.4183 18.8945 48.2863 19.2849 48.4457 19.6072C48.6052 19.9294 48.9956 20.0614 49.3179 19.902C49.6401 19.7425 49.7721 19.352 49.6127 19.0298C49.4532 18.7076 49.0627 18.5756 48.7405 18.735Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.914 20.1564C45.6009 20.3113 45.4726 20.6907 45.6275 21.0038C45.7825 21.317 46.1619 21.4452 46.475 21.2903C46.7882 21.1354 46.9164 20.7559 46.7615 20.4428C46.6065 20.1297 46.2271 20.0014 45.914 20.1564Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0826 21.5757C42.7798 21.7255 42.6547 22.0958 42.8045 22.3986C42.9543 22.7013 43.3245 22.8264 43.6273 22.6766C43.93 22.5269 44.0552 22.1566 43.9054 21.8538C43.7556 21.5511 43.3853 21.426 43.0826 21.5757Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2582 22.9995C39.9665 23.1439 39.8469 23.4977 39.9912 23.7894C40.1356 24.0811 40.4894 24.2007 40.7811 24.0564C41.0729 23.912 41.1925 23.5582 41.0481 23.2665C40.9038 22.9747 40.55 22.8552 40.2582 22.9995Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4278 24.4189C37.1471 24.5578 37.0303 24.9034 37.1692 25.1841C37.3081 25.4648 37.6536 25.5816 37.9344 25.4427C38.2151 25.3038 38.3319 24.9583 38.193 24.6775C38.0541 24.3968 37.7085 24.28 37.4278 24.4189Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5993 25.8422C34.3257 25.9776 34.2137 26.3091 34.349 26.5827C34.4844 26.8563 34.816 26.9684 35.0896 26.833C35.3632 26.6976 35.4752 26.3661 35.3398 26.0925C35.2045 25.8189 34.8729 25.7068 34.5993 25.8422Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.773 27.264C31.5116 27.3934 31.4045 27.7102 31.5338 27.9716C31.6632 28.2331 31.98 28.3401 32.2415 28.2108C32.5029 28.0814 32.61 27.7646 32.4806 27.5032C32.3513 27.2417 32.0345 27.1347 31.773 27.264Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9465 28.6795C28.6933 28.8048 28.5904 29.1092 28.7157 29.3624C28.8409 29.6156 29.1454 29.7185 29.3986 29.5932C29.6518 29.468 29.7547 29.1635 29.6294 28.9103C29.5041 28.6571 29.1997 28.5542 28.9465 28.6795Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1141 30.1008C25.8719 30.2207 25.7718 30.5169 25.8916 30.7591C26.0115 31.0013 26.3077 31.1014 26.5499 30.9816C26.7921 30.8617 26.8922 30.5655 26.7724 30.3233C26.6525 30.0811 26.3563 29.981 26.1141 30.1008Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2907 31.5305C23.0595 31.6448 22.965 31.9246 23.0794 32.1558C23.1938 32.387 23.4735 32.4815 23.7047 32.3671C23.9359 32.2528 24.0304 31.973 23.9161 31.7418C23.8017 31.5106 23.5219 31.4161 23.2907 31.5305Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4676 32.9547C20.2529 33.0609 20.1639 33.3242 20.2701 33.5389C20.3763 33.7536 20.6396 33.8426 20.8543 33.7363C21.069 33.6301 21.158 33.3668 21.0517 33.1521C20.9455 32.9375 20.6822 32.8485 20.4676 32.9547Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.633 34.3736C17.4238 34.4771 17.3376 34.7322 17.4411 34.9413C17.5446 35.1505 17.7997 35.2367 18.0089 35.1332C18.218 35.0297 18.3042 34.7747 18.2007 34.5655C18.0973 34.3563 17.8422 34.2701 17.633 34.3736Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8055 35.793C14.6074 35.891 14.5212 36.1324 14.622 36.336C14.7228 36.5397 14.9614 36.6204 15.165 36.5196C15.3687 36.4188 15.4493 36.1802 15.3486 35.9765C15.2478 35.7729 15.0092 35.6922 14.8055 35.793Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9843 37.2251C11.7988 37.3168 11.7229 37.5415 11.8147 37.727C11.9064 37.9124 12.1311 37.9884 12.3166 37.8966C12.502 37.8049 12.578 37.5801 12.4862 37.3947C12.3945 37.2093 12.1697 37.1333 11.9843 37.2251Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14877 38.6401C8.9694 38.7288 8.89594 38.9462 8.98469 39.1255C9.07343 39.3049 9.29078 39.3783 9.47014 39.2896C9.6495 39.2009 9.72298 38.9835 9.63423 38.8041C9.54549 38.6248 9.32813 38.5513 9.14877 38.6401Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32226 40.0575C6.15162 40.1419 6.0821 40.3476 6.16653 40.5183C6.25095 40.6889 6.45666 40.7584 6.6273 40.674C6.79794 40.5896 6.86746 40.3839 6.78303 40.2132C6.6986 40.0426 6.4929 39.9731 6.32226 40.0575Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49518 41.4817C3.34106 41.558 3.27709 41.7472 3.35334 41.9014C3.4296 42.0555 3.61885 42.1195 3.77298 42.0432C3.9271 41.9669 3.99107 41.7777 3.91481 41.6236C3.83855 41.4694 3.64931 41.4055 3.49518 41.4817Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.665514 42.9046C0.516551 42.9783 0.455545 43.1588 0.529248 43.3077C0.602952 43.4567 0.783454 43.5177 0.932417 43.444C1.08138 43.3703 1.1424 43.1898 1.06869 43.0408C0.994991 42.8919 0.814476 42.8309 0.665514 42.9046Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0247 0.957757C76.5899 1.17291 76.4119 1.69951 76.6271 2.13436C76.8422 2.56922 77.3688 2.7472 77.8037 2.53204C78.2385 2.31689 78.4165 1.79029 78.2014 1.35544C77.9862 0.920585 77.4596 0.7426 77.0247 0.957757Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1973 2.37909C73.7734 2.5888 73.5982 3.10717 73.8079 3.53102C74.0176 3.95486 74.536 4.13006 74.9598 3.92035C75.3837 3.71064 75.5589 3.19228 75.3492 2.76844C75.1395 2.34459 74.6211 2.16938 74.1973 2.37909Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3717 3.79262C70.9552 3.99869 70.7846 4.50338 70.9907 4.91987C71.1968 5.33635 71.7015 5.50692 72.118 5.30085C72.5344 5.09479 72.705 4.59011 72.499 4.17362C72.2929 3.75713 71.7882 3.58655 71.3717 3.79262Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5384 5.21591C68.131 5.41747 67.9642 5.91111 68.1657 6.31847C68.3673 6.72584 68.8609 6.89268 69.2683 6.69112C69.6756 6.48956 69.8425 5.99594 69.6409 5.58857C69.4394 5.18121 68.9457 5.01436 68.5384 5.21591Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7224 6.65673C65.3371 6.84738 65.1786 7.31638 65.3693 7.70169C65.5599 8.08701 66.0289 8.24552 66.4142 8.05487C66.7995 7.86423 66.958 7.39523 66.7674 7.00992C66.5768 6.62461 66.1078 6.46609 65.7224 6.65673Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.894 8.07612C62.5142 8.26404 62.3639 8.72209 62.5491 9.0964C62.7343 9.4707 63.1951 9.62643 63.5694 9.44123C63.9437 9.25603 64.0994 8.79527 63.9142 8.42096C63.729 8.04666 63.2683 7.89092 62.894 8.07612Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 9.49551C59.6957 9.67751 59.545 10.1233 59.727 10.4911C59.909 10.8589 60.3548 11.0096 60.7226 10.8276C61.0905 10.6456 61.2411 10.1999 61.0591 9.83201C60.8771 9.46416 60.4314 9.3135 60.0635 9.49551Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2266 10.8978C56.8588 11.0798 56.7081 11.5256 56.8901 11.8934C57.0721 12.2613 57.5179 12.4119 57.8857 12.2299C58.2536 12.0479 58.4042 11.6022 58.2222 11.2344C58.0402 10.8665 57.5945 10.7158 57.2266 10.8978Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4013 12.3236C54.0456 12.4996 53.8999 12.9306 54.0759 13.2862C54.2519 13.6419 54.6829 13.7876 55.0386 13.6116C55.3943 13.4356 55.54 13.0046 55.364 12.6489C55.188 12.2933 54.757 12.1476 54.4013 12.3236Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5689 13.7469C51.2221 13.9184 51.0803 14.3381 51.2519 14.6849C51.4235 15.0316 51.8431 15.1735 52.1899 15.0019C52.5367 14.8303 52.6785 14.4107 52.5069 14.0639C52.3353 13.7171 51.9157 13.5753 51.5689 13.7469Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7445 15.1687C48.4088 15.3348 48.2725 15.738 48.4386 16.0738C48.6048 16.4095 49.0079 16.5458 49.3437 16.3797C49.6795 16.2135 49.8158 15.8104 49.6496 15.4746C49.4835 15.1388 49.0803 15.0025 48.7445 15.1687Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9206 16.609C45.6044 16.7654 45.475 17.1486 45.6314 17.4647C45.7878 17.7809 46.1709 17.9104 46.4871 17.754C46.8033 17.5975 46.9328 17.2144 46.7763 16.8982C46.6199 16.5821 46.2368 16.4526 45.9206 16.609Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0982 18.0328C42.7955 18.1826 42.6703 18.5528 42.8201 18.8556C42.9699 19.1583 43.3402 19.2835 43.6429 19.1337C43.9457 18.9839 44.0708 18.6136 43.921 18.3109C43.7712 18.0081 43.401 17.883 43.0982 18.0328Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2688 19.4502C39.9715 19.5973 39.8547 19.9566 39.999 20.2483C40.1433 20.5401 40.5054 20.6624 40.7971 20.5181C41.0889 20.3737 41.2139 20.0172 41.0669 19.72C40.9198 19.4227 40.5605 19.3059 40.2688 19.4502Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4289 20.8565C37.1317 21.0035 37.0148 21.3628 37.1592 21.6546C37.3035 21.9463 37.66 22.0714 37.9573 21.9243C38.2545 21.7773 38.3741 21.4235 38.227 21.1262C38.08 20.829 37.7207 20.7121 37.4289 20.8565Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6014 22.2739C34.3152 22.4155 34.1984 22.7611 34.34 23.0473C34.4816 23.3336 34.8272 23.4504 35.1134 23.3087C35.3997 23.1671 35.5165 22.8215 35.3748 22.5353C35.2332 22.2491 34.8877 22.1323 34.6014 22.2739Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7749 23.6952C31.4942 23.8341 31.3857 24.1688 31.5218 24.444C31.658 24.7192 31.9953 24.8332 32.2706 24.6971C32.5458 24.5609 32.6598 24.2235 32.5236 23.9483C32.3875 23.6731 32.0501 23.5591 31.7749 23.6952Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9466 25.121C28.6824 25.2517 28.574 25.5726 28.7047 25.8368C28.8354 26.101 29.1563 26.2095 29.4205 26.0787C29.6847 25.948 29.7932 25.6271 29.6625 25.3629C29.5317 25.0987 29.2108 24.9902 28.9466 25.121Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1288 26.5579C25.8866 26.6777 25.7864 26.9739 25.9063 27.2161C26.0261 27.4583 26.3223 27.5584 26.5645 27.4386C26.8067 27.3188 26.9068 27.0225 26.787 26.7804C26.6672 26.5382 26.371 26.438 26.1288 26.5579Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3044 27.9855C23.0734 28.0999 22.9787 28.3798 23.093 28.6109C23.2074 28.8419 23.4873 28.9365 23.7184 28.8222C23.9494 28.7079 24.044 28.4279 23.9297 28.1969C23.8154 27.9659 23.5354 27.8712 23.3044 27.9855Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.473 29.4069C20.2511 29.5167 20.1602 29.7856 20.27 30.0075C20.3798 30.2294 20.6487 30.3203 20.8706 30.2105C21.0926 30.1007 21.1834 29.8318 21.0736 29.6099C20.9638 29.388 20.6949 29.2971 20.473 29.4069Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6371 30.8092C17.4151 30.919 17.3242 31.1879 17.434 31.4099C17.5439 31.6318 17.8128 31.7227 18.0347 31.6129C18.2566 31.5031 18.3475 31.2342 18.2377 31.0122C18.1279 30.7903 17.859 30.6994 17.6371 30.8092Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8086 32.2286C14.5939 32.3348 14.5077 32.5899 14.6139 32.8046C14.7201 33.0193 14.9752 33.1055 15.1899 32.9992C15.4045 32.893 15.4908 32.638 15.3846 32.4233C15.2783 32.2086 15.0233 32.1224 14.8086 32.2286Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9842 33.6602C11.7861 33.7582 11.6999 33.9996 11.8007 34.2032C11.9015 34.4069 12.1401 34.4876 12.3437 34.3868C12.5474 34.286 12.628 34.0474 12.5273 33.8437C12.4265 33.6401 12.1879 33.5594 11.9842 33.6602Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16127 35.0908C8.97886 35.181 8.90416 35.402 8.9944 35.5845C9.08465 35.7669 9.30568 35.8416 9.48809 35.7513C9.67049 35.6611 9.7452 35.44 9.65495 35.2576C9.5647 35.0752 9.34367 35.0005 9.16127 35.0908Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33496 36.5145C6.16472 36.5988 6.09499 36.8051 6.17923 36.9753C6.26346 37.1455 6.46975 37.2153 6.63999 37.131C6.81023 37.0468 6.87996 36.8405 6.79573 36.6703C6.71149 36.5 6.5052 36.4303 6.33496 36.5145Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50885 37.9466C3.35472 38.0228 3.29076 38.2121 3.36702 38.3662C3.44327 38.5203 3.63252 38.5843 3.78665 38.508C3.94077 38.4318 4.00474 38.2425 3.92849 38.0884C3.85223 37.9343 3.66297 37.8703 3.50885 37.9466Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.684081 39.3655C0.53546 39.439 0.474268 39.62 0.547803 39.7687C0.621338 39.9173 0.802367 39.9785 0.950988 39.9049C1.09961 39.8314 1.16078 39.6504 1.08725 39.5018C1.01371 39.3531 0.832702 39.292 0.684081 39.3655Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2148 -1.15997C73.791 -0.950259 73.6158 -0.431895 73.8255 -0.00804928C74.0352 0.415797 74.5536 0.591001 74.9774 0.38129C75.4013 0.17158 75.5765 -0.346788 75.3668 -0.770634C75.157 -1.19448 74.6387 -1.36968 74.2148 -1.15997Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3825 0.259417C70.9641 0.466404 70.7945 0.968309 71.0015 1.38665C71.2084 1.80499 71.7104 1.97464 72.1287 1.76765C72.547 1.56066 72.7167 1.05875 72.5097 0.64041C72.3027 0.222068 71.8008 0.0524299 71.3825 0.259417Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5559 1.6788C68.1486 1.88036 67.9817 2.37399 68.1833 2.78136C68.3848 3.18872 68.8785 3.35557 69.2858 3.15401C69.6932 2.95246 69.86 2.45882 69.6585 2.05145C69.4569 1.64409 68.9633 1.47725 68.5559 1.6788Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7275 3.0982C65.3292 3.29524 65.1661 3.77782 65.3632 4.17607C65.5602 4.57431 66.0428 4.73742 66.441 4.54037C66.8393 4.34333 67.0024 3.86075 66.8053 3.46251C66.6083 3.06426 66.1257 2.90115 65.7275 3.0982Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8982 4.52783C62.5129 4.71847 62.3544 5.18746 62.545 5.57278C62.7357 5.95809 63.2047 6.11661 63.59 5.92597C63.9753 5.73532 64.1338 5.26632 63.9432 4.88101C63.7525 4.49569 63.2835 4.33718 62.8982 4.52783Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0707 5.94331C59.6938 6.12982 59.5394 6.58661 59.7259 6.96358C59.9124 7.34054 60.3692 7.49494 60.7462 7.30842C61.1231 7.12191 61.2775 6.66511 61.091 6.28814C60.9045 5.91118 60.4477 5.75679 60.0707 5.94331Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2452 7.35878C56.8773 7.54079 56.7267 7.98652 56.9087 8.35437C57.0907 8.72222 57.5364 8.87287 57.9043 8.69087C58.2721 8.50887 58.4228 8.06313 58.2408 7.69528C58.0588 7.32743 57.613 7.17678 57.2452 7.35878Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.415 8.78646C54.0572 8.96349 53.9126 9.39134 54.0896 9.74914C54.2666 10.1069 54.6945 10.2515 55.0523 10.0745C55.4101 9.89748 55.5547 9.46963 55.3776 9.11183C55.2006 8.75404 54.7728 8.60943 54.415 8.78646Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5865 10.2078C51.2397 10.3794 51.0979 10.799 51.2694 11.1458C51.441 11.4926 51.8607 11.6344 52.2074 11.4628C52.5542 11.2912 52.6961 10.8716 52.5245 10.5248C52.3529 10.178 51.9333 10.0362 51.5865 10.2078Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7631 11.6296C48.4273 11.7958 48.2911 12.1989 48.4572 12.5347C48.6233 12.8705 49.0265 13.0067 49.3623 12.8406C49.698 12.6745 49.8343 12.2713 49.6682 11.9355C49.5021 11.5997 49.0989 11.4635 48.7631 11.6296Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9307 13.0549C45.6054 13.2158 45.4722 13.61 45.6332 13.9353C45.7941 14.2605 46.1883 14.3938 46.5136 14.2328C46.8388 14.0719 46.9721 13.6777 46.8111 13.3524C46.6502 13.0271 46.256 12.8939 45.9307 13.0549Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1042 14.4723C42.788 14.6287 42.6586 15.0118 42.815 15.328C42.9714 15.6442 43.3545 15.7737 43.6707 15.6172C43.9869 15.4608 44.1163 15.0777 43.9599 14.7615C43.8035 14.4453 43.4204 14.3159 43.1042 14.4723Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.274 15.9019C39.9712 16.0517 39.8461 16.422 39.9959 16.7247C40.1457 17.0275 40.5159 17.1526 40.8187 17.0028C41.1214 16.853 41.2466 16.4828 41.0968 16.18C40.947 15.8773 40.5767 15.7521 40.274 15.9019Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4494 17.3213C37.1522 17.4684 37.0353 17.8277 37.1797 18.1194C37.324 18.4112 37.686 18.5335 37.9778 18.3892C38.2695 18.2448 38.3919 17.8828 38.2475 17.5911C38.1032 17.2993 37.7412 17.177 37.4494 17.3213Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.62 18.7387C34.3337 18.8804 34.2169 19.2259 34.3586 19.5122C34.5002 19.7984 34.8458 19.9152 35.132 19.7736C35.4182 19.632 35.535 19.2864 35.3934 19.0002C35.2518 18.7139 34.9062 18.5971 34.62 18.7387Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7876 20.1581C31.511 20.295 31.3976 20.6302 31.5345 20.9069C31.6714 21.1835 32.0066 21.2968 32.2833 21.1599C32.5599 21.0231 32.6732 20.6878 32.5363 20.4112C32.3995 20.1346 32.0642 20.0213 31.7876 20.1581Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9622 21.5819C28.6978 21.7128 28.5894 22.0332 28.7203 22.2977C28.8512 22.5622 29.1717 22.6705 29.4361 22.5397C29.7006 22.4088 29.809 22.0883 29.6781 21.8238C29.5472 21.5594 29.2267 21.451 28.9622 21.5819Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1398 23.0037C25.8866 23.129 25.7837 23.4334 25.909 23.6866C26.0343 23.9398 26.3387 24.0427 26.592 23.9175C26.8452 23.7922 26.9481 23.4877 26.8228 23.2345C26.6975 22.9813 26.3931 22.8784 26.1398 23.0037Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3055 24.429C23.0633 24.5488 22.9632 24.845 23.083 25.0872C23.2029 25.3294 23.4991 25.4295 23.7413 25.3097C23.9835 25.1898 24.0836 24.8936 23.9638 24.6514C23.8439 24.4092 23.5477 24.3091 23.3055 24.429Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4831 25.8527C20.2519 25.9671 20.1574 26.2469 20.2718 26.4781C20.3861 26.7092 20.6659 26.8038 20.8971 26.6894C21.1283 26.575 21.2228 26.2953 21.1084 26.0641C20.9941 25.8329 20.7143 25.7383 20.4831 25.8527Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6556 27.2741C17.4337 27.3839 17.3428 27.6528 17.4526 27.8747C17.5624 28.0966 17.8313 28.1875 18.0532 28.0777C18.2752 27.9679 18.3661 27.699 18.2563 27.4771C18.1465 27.2551 17.8775 27.1643 17.6556 27.2741Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8223 28.6915C14.6095 28.7968 14.5223 29.0547 14.6276 29.2675C14.7329 29.4803 14.9908 29.5674 15.2036 29.4621C15.4164 29.3568 15.5035 29.099 15.3982 28.8862C15.2929 28.6734 15.0351 28.5862 14.8223 28.6915Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9969 30.1153C11.7988 30.2133 11.7126 30.4546 11.8134 30.6583C11.9142 30.862 12.1528 30.9426 12.3564 30.8419C12.5601 30.7411 12.6407 30.5025 12.54 30.2988C12.4392 30.0951 12.2006 30.0145 11.9969 30.1153Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17138 31.5366C8.97986 31.6314 8.90143 31.8634 8.99619 32.055C9.09095 32.2465 9.32302 32.3249 9.51454 32.2302C9.70607 32.1354 9.78451 31.9033 9.68975 31.7118C9.59498 31.5203 9.3629 31.4419 9.17138 31.5366Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33802 32.956C6.15562 33.0462 6.08093 33.2673 6.17118 33.4497C6.26142 33.6321 6.48244 33.7068 6.66484 33.6165C6.84725 33.5263 6.92195 33.3053 6.8317 33.1229C6.74146 32.9404 6.52043 32.8658 6.33802 32.956Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51269 34.3837C3.34205 34.4681 3.27253 34.6738 3.35696 34.8444C3.44139 35.0151 3.64709 35.0846 3.81773 35.0002C3.98837 34.9157 4.05789 34.71 3.97346 34.5394C3.88903 34.3688 3.68333 34.2992 3.51269 34.3837Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.690493 35.806C0.536368 35.8822 0.472398 36.0715 0.548656 36.2256C0.624915 36.3797 0.814163 36.4437 0.968289 36.3674C1.12241 36.2912 1.18638 36.1019 1.11013 35.9478C1.03387 35.7937 0.844619 35.7297 0.690493 35.806Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5617 -1.88606C68.1379 -1.67634 67.9654 -1.16621 68.1752 -0.742367C68.3849 -0.318521 68.895 -0.146096 69.3189 -0.355807C69.7427 -0.565517 69.9151 -1.07566 69.7054 -1.49951C69.4957 -1.92335 68.9856 -2.09577 68.5617 -1.88606Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7293 -0.462762C65.3159 -0.258197 65.1466 0.242792 65.3511 0.656239C65.5557 1.06969 66.0567 1.23903 66.4701 1.03446C66.8836 0.829895 67.0529 0.328889 66.8483 -0.0845574C66.6438 -0.498004 66.1428 -0.667328 65.7293 -0.462762Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9134 0.978059C62.5226 1.17143 62.3613 1.64864 62.5547 2.03946C62.748 2.43028 63.2253 2.59158 63.6161 2.39821C64.0069 2.20484 64.1682 1.72761 63.9748 1.33679C63.7815 0.945971 63.3042 0.784689 62.9134 0.978059Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0883 2.39838C59.7085 2.5863 59.5583 3.04436 59.7435 3.41866C59.9287 3.79297 60.3894 3.9487 60.7637 3.7635C61.138 3.5783 61.2938 3.11753 61.1086 2.74323C60.9234 2.36892 60.4626 2.21318 60.0883 2.39838Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2579 3.82558C56.89 4.00758 56.7394 4.45331 56.9214 4.82116C57.1034 5.18901 57.5491 5.33968 57.917 5.15767C58.2848 4.97567 58.4355 4.52991 58.2535 4.16207C58.0715 3.79422 57.6257 3.64357 57.2579 3.82558Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4229 5.22987C54.0551 5.41187 53.9044 5.85761 54.0864 6.22546C54.2684 6.5933 54.7142 6.74397 55.082 6.56196C55.4499 6.37996 55.6005 5.93421 55.4185 5.56637C55.2365 5.19852 54.7908 5.04787 54.4229 5.22987Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5933 6.64295C51.2315 6.82194 51.0833 7.2603 51.2623 7.62206C51.4413 7.98383 51.8797 8.132 52.2414 7.95301C52.6032 7.77401 52.7514 7.33564 52.5724 6.97387C52.3934 6.6121 51.955 6.46396 51.5933 6.64295Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7609 8.06624C48.4086 8.24054 48.264 8.66839 48.4383 9.02067C48.6126 9.37296 49.0404 9.51757 49.3927 9.34327C49.745 9.16896 49.8896 8.74111 49.7153 8.38882C49.541 8.03653 49.1132 7.89193 48.7609 8.06624Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9357 9.48852C45.5945 9.65737 45.4609 10.0661 45.6271 10.4018C45.7932 10.7376 46.2046 10.8766 46.5404 10.7105C46.8761 10.5444 47.0152 10.133 46.8491 9.79721C46.6829 9.46144 46.2715 9.32238 45.9357 9.48852Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1116 10.9264C42.7923 11.0844 42.6561 11.4738 42.8168 11.7986C42.9775 12.1233 43.3642 12.2541 43.689 12.0934C44.0137 11.9327 44.1444 11.546 43.9838 11.2212C43.8231 10.8964 43.4364 10.7657 43.1116 10.9264Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2875 12.3526C39.9792 12.5051 39.8541 12.8754 40.0066 13.1837C40.1591 13.4919 40.5294 13.617 40.8376 13.4645C41.1459 13.312 41.271 12.9418 41.1185 12.6335C40.966 12.3253 40.5957 12.2001 40.2875 12.3526Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4607 13.7715C37.1635 13.9186 37.0356 14.2833 37.1854 14.5861C37.3352 14.8888 37.6972 15.0112 38 14.8614C38.3027 14.7116 38.4251 14.3496 38.2753 14.0468C38.1255 13.7441 37.7635 13.6217 37.4607 13.7715Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6218 15.1758C34.3246 15.3229 34.1967 15.6876 34.3465 15.9904C34.4963 16.2931 34.8584 16.4155 35.1611 16.2657C35.4639 16.1159 35.5862 15.7539 35.4364 15.4511C35.2866 15.1484 34.9246 15.026 34.6218 15.1758Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7948 16.5942C31.5085 16.7358 31.3917 17.0814 31.5334 17.3676C31.675 17.6539 32.0206 17.7707 32.3068 17.6291C32.593 17.4874 32.7098 17.1419 32.5682 16.8556C32.4266 16.5694 32.081 16.4526 31.7948 16.5942Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9692 18.0175C28.6885 18.1564 28.58 18.491 28.7162 18.7663C28.8523 19.0415 29.1897 19.1555 29.4649 19.0193C29.7401 18.8831 29.8542 18.5458 29.718 18.2706C29.5818 17.9953 29.2445 17.8813 28.9692 18.0175Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.138 19.4452C25.8738 19.5759 25.7654 19.8968 25.8961 20.161C26.0268 20.4252 26.3477 20.5337 26.6119 20.403C26.8761 20.2722 26.9846 19.9513 26.8539 19.6871C26.7231 19.4229 26.4023 19.3145 26.138 19.4452Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3209 20.8797C23.0732 21.0022 22.9731 21.2984 23.0957 21.5461C23.2182 21.7938 23.5144 21.8939 23.7621 21.7714C24.0098 21.6488 24.11 21.3526 23.9874 21.1049C23.8648 20.8572 23.5686 20.7571 23.3209 20.8797Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4985 22.3112C20.2644 22.427 20.1686 22.7107 20.2844 22.9448C20.4002 23.1789 20.6839 23.2747 20.918 23.1589C21.152 23.0431 21.2479 22.7594 21.1321 22.5254C21.0163 22.2913 20.7326 22.1954 20.4985 22.3112Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6652 23.7306C17.4402 23.8419 17.3481 24.1145 17.4594 24.3395C17.5707 24.5644 17.8433 24.6566 18.0683 24.5453C18.2932 24.434 18.3853 24.1614 18.274 23.9364C18.1627 23.7114 17.8901 23.6193 17.6652 23.7306Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8292 25.133C14.6043 25.2443 14.5121 25.5169 14.6234 25.7418C14.7347 25.9668 15.0073 26.0589 15.2323 25.9476C15.4573 25.8363 15.5494 25.5637 15.4381 25.3387C15.3268 25.1138 15.0542 25.0217 14.8292 25.133Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 26.5465C11.7861 26.6527 11.6971 26.916 11.8033 27.1307C11.9095 27.3454 12.1728 27.4343 12.3875 27.3281C12.6022 27.2219 12.6912 26.9586 12.585 26.744C12.4787 26.5293 12.2154 26.4403 12.0008 26.5465Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17152 27.9761C8.96785 28.0769 8.88443 28.3237 8.9852 28.5274C9.08597 28.7311 9.3328 28.8145 9.53646 28.7137C9.74013 28.613 9.82357 28.3661 9.7228 28.1625C9.62203 27.9588 9.37518 27.8754 9.17152 27.9761Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35658 29.4189C6.17418 29.5091 6.09946 29.7302 6.18971 29.9126C6.27996 30.095 6.501 30.1697 6.6834 30.0794C6.8658 29.9892 6.94051 29.7681 6.85026 29.5857C6.76001 29.4033 6.53899 29.3286 6.35658 29.4189Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53222 30.8446C3.36158 30.929 3.29205 31.1347 3.37648 31.3054C3.46091 31.476 3.66662 31.5455 3.83726 31.4611C4.0079 31.3767 4.07741 31.171 3.99298 31.0003C3.90855 30.8297 3.70286 30.7602 3.53222 30.8446Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.700821 32.264C0.54119 32.343 0.474447 32.5404 0.553429 32.7001C0.632411 32.8597 0.829882 32.9265 0.989512 32.8475C1.14914 32.7685 1.21589 32.571 1.1369 32.4114C1.05792 32.2518 0.860451 32.185 0.700821 32.264Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0831 -1.16696C59.6868 -0.970865 59.5255 -0.493634 59.7216 -0.09731C59.9177 0.299014 60.3949 0.460307 60.7912 0.264214C61.1876 0.0681209 61.3489 -0.409098 61.1528 -0.805421C60.9567 -1.20174 60.4795 -1.36305 60.0831 -1.16696Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2576 0.252429C56.8723 0.443075 56.7138 0.912083 56.9044 1.2974C57.0951 1.68271 57.564 1.84122 57.9494 1.65058C58.3347 1.45993 58.4932 0.990937 58.3026 0.605623C58.1119 0.220308 57.6429 0.0617831 57.2576 0.252429Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4272 1.6679C54.0474 1.85583 53.8971 2.31389 54.0823 2.68819C54.2675 3.0625 54.7283 3.21822 55.1026 3.03303C55.4769 2.84783 55.6326 2.38707 55.4474 2.01276C55.2622 1.63845 54.8015 1.48271 54.4272 1.6679Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5977 3.0912C51.2289 3.27367 51.0787 3.718 51.2612 4.0868C51.4437 4.4556 51.888 4.60577 52.2568 4.42329C52.6256 4.24082 52.7758 3.79651 52.5933 3.42771C52.4108 3.05891 51.9665 2.90872 51.5977 3.0912Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7724 4.51693C48.4146 4.69396 48.27 5.12183 48.447 5.47962C48.624 5.83741 49.0519 5.98201 49.4097 5.80498C49.7675 5.62795 49.9121 5.2001 49.7351 4.84231C49.558 4.48452 49.1302 4.3399 48.7724 4.51693Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.948 5.94071C45.6067 6.10957 45.4649 6.5292 45.6338 6.87048C45.8026 7.21175 46.2223 7.35357 46.5635 7.18471C46.9048 7.01585 47.0467 6.59624 46.8778 6.25496C46.7089 5.91368 46.2893 5.77185 45.948 5.94071Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1156 7.35814C42.7799 7.52428 42.6436 7.92745 42.8097 8.26322C42.9759 8.599 43.379 8.73525 43.7148 8.56912C44.0506 8.40299 44.1869 7.99982 44.0207 7.66405C43.8546 7.32828 43.4514 7.19201 43.1156 7.35814Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2932 8.78774C39.974 8.9457 39.8378 9.33516 39.9985 9.65992C40.1591 9.98469 40.5459 10.1154 40.8706 9.95471C41.1954 9.79402 41.3261 9.40731 41.1654 9.08254C41.0047 8.75778 40.618 8.62705 40.2932 8.78774Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4589 10.2071C37.1452 10.3624 37.0172 10.7409 37.1725 11.0546C37.3277 11.3684 37.7062 11.4963 38.02 11.3411C38.3337 11.1858 38.4616 10.8073 38.3064 10.4936C38.1512 10.1798 37.7727 10.0519 37.4589 10.2071Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6314 11.6265C34.3287 11.7763 34.2035 12.1466 34.3533 12.4493C34.5031 12.7521 34.8734 12.8772 35.1761 12.7274C35.4789 12.5776 35.604 12.2074 35.4542 11.9046C35.3044 11.6019 34.9342 11.4767 34.6314 11.6265Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.807 13.0483C31.5153 13.1927 31.3957 13.5465 31.5401 13.8382C31.6844 14.13 32.0382 14.2496 32.33 14.1052C32.6217 13.9609 32.7413 13.6071 32.5969 13.3153C32.4526 13.0236 32.0988 12.904 31.807 13.0483Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9747 14.4716C28.6939 14.6105 28.5771 14.9561 28.716 15.2368C28.8549 15.5176 29.2005 15.6344 29.4812 15.4955C29.762 15.3566 29.8788 15.011 29.7399 14.7303C29.601 14.4495 29.2554 14.3327 28.9747 14.4716Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1481 15.8891C25.8729 16.0252 25.7617 16.3544 25.8979 16.6296C26.034 16.9048 26.3632 17.0161 26.6384 16.8799C26.9136 16.7437 27.0249 16.4146 26.8887 16.1394C26.7525 15.8641 26.4234 15.7529 26.1481 15.8891Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3228 17.3148C23.0641 17.4428 22.9529 17.7582 23.0837 18.0224C23.2144 18.2866 23.527 18.3923 23.7913 18.2616C24.0555 18.1308 24.1612 17.8182 24.0304 17.554C23.8997 17.2897 23.587 17.1841 23.3228 17.3148Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4904 18.7342C20.2372 18.8595 20.1343 19.1639 20.2596 19.4171C20.3849 19.6703 20.6893 19.7732 20.9425 19.6479C21.1957 19.5226 21.2986 19.2182 21.1734 18.965C21.0481 18.7118 20.7436 18.6089 20.4904 18.7342Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6649 20.1536C17.4227 20.2734 17.3226 20.5696 17.4424 20.8118C17.5623 21.054 17.8585 21.1541 18.1007 21.0343C18.3429 20.9144 18.443 20.6183 18.3231 20.3761C18.2033 20.1339 17.9071 20.0337 17.6649 20.1536Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8405 21.5793C14.6093 21.6937 14.5148 21.9734 14.6292 22.2046C14.7436 22.4358 15.0233 22.5304 15.2545 22.416C15.4857 22.3016 15.5803 22.0218 15.4659 21.7907C15.3515 21.5595 15.0717 21.4649 14.8405 21.5793Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0125 23.0094C11.7978 23.1156 11.7088 23.3789 11.815 23.5936C11.9212 23.8083 12.1845 23.8972 12.3992 23.791C12.6139 23.6848 12.7029 23.4215 12.5967 23.2068C12.4905 22.9922 12.2272 22.9032 12.0125 23.0094Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18577 24.4283C8.97659 24.5318 8.89038 24.7869 8.99388 24.996C9.09737 25.2052 9.35244 25.2914 9.56161 25.1879C9.77078 25.0844 9.85698 24.8294 9.75348 24.6202C9.64999 24.411 9.39494 24.3248 9.18577 24.4283Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36159 25.8525C6.16343 25.9506 6.0883 26.1865 6.18362 26.3791C6.27895 26.5718 6.51755 26.6524 6.7102 26.5571C6.90286 26.4618 6.98352 26.2232 6.8882 26.0305C6.79288 25.8379 6.55425 25.7572 6.36159 25.8525Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52921 27.2739C3.34206 27.3665 3.26971 27.5942 3.35959 27.7758C3.44946 27.9574 3.67983 28.0353 3.86148 27.9454C4.04313 27.8556 4.12101 27.6252 4.03114 27.4435C3.94126 27.2619 3.71086 27.184 3.52921 27.2739Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.706818 28.7035C0.530674 28.7907 0.463888 29.0019 0.548317 29.1725C0.632746 29.3432 0.846655 29.4155 1.01729 29.331C1.18793 29.2466 1.26025 29.0327 1.17582 28.862C1.09139 28.6914 0.877458 28.6191 0.706818 28.7035Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6069 -0.462954C51.227 -0.275032 51.0768 0.183009 51.262 0.557315C51.4472 0.93162 51.908 1.08737 52.2823 0.902166C52.6566 0.716967 52.8123 0.25619 52.6271 -0.118116C52.4419 -0.492421 51.9812 -0.648153 51.6069 -0.462954Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7794 0.954483C48.4115 1.13649 48.2609 1.58222 48.4429 1.95007C48.6249 2.31791 49.0706 2.46858 49.4384 2.28658C49.8063 2.10458 49.9569 1.65882 49.7749 1.29098C49.5929 0.923129 49.1472 0.772481 48.7794 0.954483Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9501 2.38412C45.5923 2.56114 45.4477 2.98899 45.6247 3.34678C45.8018 3.70458 46.2296 3.84919 46.5874 3.67217C46.9452 3.49514 47.0898 3.06727 46.9128 2.70948C46.7358 2.35169 46.3079 2.20709 45.9501 2.38412Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1226 3.8035C42.7758 3.97508 42.634 4.3947 42.8056 4.74149C42.9772 5.08827 43.3968 5.23011 43.7436 5.05853C44.0904 4.88695 44.2322 4.46731 44.0606 4.12053C43.889 3.77374 43.4694 3.63192 43.1226 3.8035Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2999 5.24237C39.9751 5.40306 39.8416 5.79799 40.0023 6.12275C40.163 6.44752 40.5579 6.58101 40.8827 6.42032C41.2075 6.25964 41.3409 5.86469 41.1803 5.53992C41.0196 5.21516 40.6246 5.08168 40.2999 5.24237Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4724 6.66371C37.1562 6.82014 37.0267 7.20325 37.1831 7.51941C37.3396 7.83558 37.7227 7.96507 38.0389 7.80864C38.355 7.65221 38.4845 7.26908 38.3281 6.95292C38.1716 6.63675 37.7885 6.50728 37.4724 6.66371Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6509 8.08747C34.3482 8.23726 34.2231 8.60752 34.3728 8.91027C34.5226 9.21302 34.8929 9.33816 35.1956 9.18837C35.4984 9.03857 35.6235 8.66831 35.4737 8.36557C35.3239 8.06282 34.9537 7.93767 34.6509 8.08747Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8091 9.49567C31.5064 9.64546 31.3813 10.0157 31.531 10.3185C31.6808 10.6212 32.0511 10.7464 32.3538 10.5966C32.6566 10.4468 32.7817 10.0765 32.6319 9.77377C32.4822 9.47102 32.1119 9.34588 31.8091 9.49567Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9807 10.9111C28.6834 11.0582 28.5666 11.4175 28.7109 11.7093C28.8553 12.001 29.2118 12.1261 29.509 11.979C29.8063 11.832 29.9231 11.4726 29.7788 11.1809C29.6344 10.8892 29.2724 10.7668 28.9807 10.9111Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1532 12.3305C25.8669 12.4722 25.7501 12.8177 25.8918 13.104C26.0334 13.3902 26.379 13.507 26.6652 13.3654C26.9514 13.2238 27.0682 12.8782 26.9266 12.592C26.785 12.3057 26.4394 12.1889 26.1532 12.3305Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3249 13.7582C23.0513 13.8936 22.9392 14.2251 23.0746 14.4987C23.21 14.7723 23.5415 14.8844 23.8151 14.749C24.0887 14.6137 24.2008 14.2821 24.0654 14.0085C23.9301 13.7349 23.5985 13.6228 23.3249 13.7582Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.509 15.1971C20.2558 15.3224 20.1529 15.6268 20.2782 15.88C20.4034 16.1332 20.7079 16.2361 20.9611 16.1108C21.2143 15.9855 21.3172 15.6811 21.1919 15.4279C21.0666 15.1747 20.7622 15.0718 20.509 15.1971Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6805 16.6165C17.4383 16.7363 17.3382 17.0325 17.458 17.2747C17.5779 17.5169 17.8741 17.617 18.1163 17.4972C18.3585 17.3773 18.4586 17.0811 18.3388 16.8389C18.2189 16.5967 17.9227 16.4966 17.6805 16.6165Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8513 18.0441C14.6202 18.1585 14.5256 18.4384 14.6399 18.6695C14.7542 18.9005 15.0342 18.9951 15.2653 18.8808C15.4963 18.7665 15.5909 18.4865 15.4766 18.2555C15.3623 18.0244 15.0823 17.9298 14.8513 18.0441Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0183 19.4465C11.7872 19.5608 11.6926 19.8408 11.8069 20.0718C11.9212 20.3028 12.2012 20.3975 12.4322 20.2832C12.6633 20.1688 12.7579 19.8889 12.6436 19.6578C12.5293 19.4268 12.2493 19.3322 12.0183 19.4465Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19315 20.8707C8.97847 20.9769 8.88949 21.2402 8.99571 21.4549C9.10192 21.6696 9.36521 21.7586 9.57989 21.6524C9.79456 21.5461 9.88355 21.2828 9.77734 21.0682C9.67112 20.8535 9.40782 20.7645 9.19315 20.8707Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36055 22.2896C6.15138 22.3931 6.06517 22.6482 6.16866 22.8574C6.27216 23.0665 6.52723 23.1527 6.7364 23.0493C6.94557 22.9458 7.03178 22.6907 6.92829 22.4815C6.82479 22.2723 6.56972 22.1861 6.36055 22.2896Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54583 23.7387C3.36039 23.8305 3.28443 24.0552 3.37618 24.2406C3.46793 24.4261 3.69266 24.502 3.8781 24.4103C4.06354 24.3185 4.13948 24.0938 4.04773 23.9084C3.95598 23.7229 3.73128 23.647 3.54583 23.7387Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.716169 25.1479C0.536806 25.2366 0.463347 25.454 0.552092 25.6333C0.640837 25.8127 0.858178 25.8862 1.03754 25.7974C1.2169 25.7087 1.29036 25.4913 1.20162 25.312C1.11287 25.1326 0.895532 25.0591 0.716169 25.1479Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9667 -1.16081C45.6089 -0.983777 45.4643 -0.555926 45.6413 -0.198134C45.8184 0.159658 46.2462 0.304273 46.604 0.127244C46.9618 -0.049784 47.1064 -0.477647 46.9294 -0.835439C46.7524 -1.19323 46.3245 -1.33783 45.9667 -1.16081Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1392 0.260535C42.7924 0.432116 42.6506 0.851736 42.8222 1.19852C42.9938 1.5453 43.4134 1.68714 43.7602 1.51556C44.107 1.34398 44.2488 0.924341 44.0772 0.577558C43.9056 0.230775 43.486 0.0889534 43.1392 0.260535Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.309 1.68627C39.9732 1.8524 39.837 2.25556 40.0031 2.59133C40.1692 2.92711 40.5724 3.06338 40.9082 2.89724C41.2439 2.73111 41.3802 2.32793 41.2141 1.99216C41.0479 1.65638 40.6448 1.52013 40.309 1.68627Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4844 3.10758C37.1592 3.26853 37.0259 3.6627 37.1869 3.98799C37.3478 4.31327 37.742 4.4465 38.0673 4.28555C38.3926 4.12461 38.5258 3.73044 38.3648 3.40516C38.2039 3.07987 37.8097 2.94664 37.4844 3.10758Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6511 4.52893C34.3349 4.68536 34.2054 5.06848 34.3619 5.38464C34.5183 5.70081 34.9014 5.83031 35.2176 5.67387C35.5337 5.51744 35.6632 5.13432 35.5068 4.81815C35.3504 4.50199 34.9672 4.3725 34.6511 4.52893Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8277 5.95661C31.525 6.1064 31.3998 6.47666 31.5496 6.77941C31.6994 7.08216 32.0697 7.2073 32.3724 7.05751C32.6751 6.90771 32.8003 6.53745 32.6505 6.23471C32.5007 5.93196 32.1304 5.80682 31.8277 5.95661Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9983 7.37211C28.701 7.51918 28.5841 7.87847 28.7285 8.17021C28.8728 8.46195 29.2349 8.58431 29.5266 8.43996C29.8183 8.29562 29.9407 7.93358 29.7964 7.64184C29.652 7.35011 29.29 7.22776 28.9983 7.37211Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1678 8.79342C25.8821 8.93482 25.765 9.2811 25.9064 9.56686C26.0478 9.85262 26.3941 9.96966 26.6799 9.82827C26.9656 9.68688 27.0826 9.34061 26.9413 9.05484C26.7999 8.76908 26.4536 8.65203 26.1678 8.79342Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3435 10.2211C23.0699 10.3565 22.9578 10.688 23.0932 10.9616C23.2285 11.2352 23.5601 11.3473 23.8337 11.2119C24.1073 11.0765 24.2194 10.745 24.084 10.4714C23.9486 10.1978 23.6171 10.0857 23.3435 10.2211Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5169 11.6385C20.2525 11.7694 20.1441 12.0899 20.275 12.3544C20.4059 12.6189 20.7264 12.7272 20.9908 12.5963C21.2553 12.4655 21.3636 12.145 21.2328 11.8805C21.1019 11.616 20.7814 11.5077 20.5169 11.6385Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6857 13.0643C17.4325 13.1895 17.3296 13.494 17.4549 13.7472C17.5802 14.0004 17.8846 14.1033 18.1379 13.978C18.3911 13.8527 18.494 13.5483 18.3687 13.2951C18.2434 13.0419 17.939 12.939 17.6857 13.0643Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8583 14.4797C14.6161 14.5996 14.5159 14.8958 14.6358 15.138C14.7556 15.3802 15.0518 15.4803 15.294 15.3605C15.5362 15.2406 15.6363 14.9444 15.5165 14.7022C15.3967 14.46 15.1005 14.3599 14.8583 14.4797Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0358 15.9113C11.8048 16.0256 11.7102 16.3056 11.8245 16.5366C11.9388 16.7677 12.2188 16.8623 12.4498 16.748C12.6809 16.6337 12.7755 16.3537 12.6612 16.1227C12.5469 15.8916 12.2669 15.797 12.0358 15.9113Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20976 17.3414C8.99391 17.4482 8.9055 17.7098 9.01229 17.9256C9.11909 18.1415 9.38065 18.2298 9.59649 18.1231C9.81233 18.0163 9.90073 17.7547 9.79394 17.5389C9.68714 17.323 9.4256 17.2346 9.20976 17.3414Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37815 18.7545C6.16898 18.858 6.08277 19.113 6.18626 19.3222C6.28975 19.5314 6.54482 19.6176 6.75399 19.5141C6.96317 19.4106 7.04936 19.1555 6.94587 18.9464C6.84237 18.7372 6.58732 18.651 6.37815 18.7545Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55161 20.1719C3.35345 20.27 3.26729 20.5113 3.36806 20.715C3.46883 20.9186 3.70745 20.9993 3.91112 20.8985C4.11478 20.7977 4.19543 20.5591 4.09466 20.3555C3.99389 20.1518 3.75528 20.0711 3.55161 20.1719Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.72062 21.6001C0.533467 21.6927 0.461108 21.9203 0.550984 22.102C0.64086 22.2836 0.87124 22.3615 1.05289 22.2716C1.23454 22.1817 1.31241 21.9513 1.22253 21.7697C1.13266 21.588 0.902268 21.5102 0.72062 21.6001Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4938 -0.438266C37.1635 -0.274855 37.0272 0.128315 37.1907 0.458584C37.3541 0.788854 37.7572 0.925121 38.0875 0.76171C38.4178 0.598299 38.554 0.195126 38.3906 -0.135144C38.2272 -0.465414 37.824 -0.601677 37.4938 -0.438266Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6614 0.97721C34.3392 1.13665 34.2072 1.52713 34.3666 1.84938C34.5261 2.17162 34.9165 2.3036 35.2388 2.14416C35.561 1.98472 35.693 1.59424 35.5336 1.27199C35.3741 0.949749 34.9837 0.81777 34.6614 0.97721Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8392 2.40341C31.5322 2.55533 31.4064 2.92738 31.5583 3.23443C31.7102 3.54147 32.0823 3.66723 32.3894 3.51531C32.6964 3.36339 32.8222 2.99132 32.6702 2.68428C32.5183 2.37723 32.1463 2.25149 31.8392 2.40341Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9994 3.80966C28.6923 3.96158 28.5666 4.33363 28.7185 4.64067C28.8704 4.94772 29.2425 5.07348 29.5495 4.92156C29.8566 4.76964 29.9823 4.39757 29.8304 4.09053C29.6785 3.78348 29.3064 3.65774 28.9994 3.80966Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1717 5.23248C25.8744 5.37955 25.7466 5.7443 25.8963 6.04705C26.0461 6.3498 26.4082 6.47215 26.7109 6.32236C27.0137 6.17257 27.136 5.81054 26.9862 5.50779C26.8364 5.20505 26.4744 5.08269 26.1717 5.23248Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3485 6.6528C23.0623 6.79443 22.9454 7.14001 23.0871 7.42624C23.2287 7.71247 23.5743 7.82927 23.8605 7.68765C24.1467 7.54603 24.2635 7.20045 24.1219 6.91422C23.9803 6.62798 23.6347 6.51118 23.3485 6.6528Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5141 8.07805C20.2334 8.21695 20.1249 8.55157 20.2611 8.8268C20.3973 9.10202 20.7346 9.21605 21.0098 9.07987C21.2851 8.9437 21.3991 8.60634 21.2629 8.33112C21.1267 8.0559 20.7894 7.94187 20.5141 8.07805Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6992 9.51496C17.4405 9.64297 17.3403 9.9529 17.4656 10.2061C17.5909 10.4593 17.9036 10.565 18.1568 10.4397C18.41 10.3144 18.5156 10.0018 18.3904 9.74856C18.2651 9.49536 17.9524 9.38968 17.6992 9.51496Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8749 10.9407C14.6317 11.061 14.532 11.3557 14.6524 11.5989C14.7727 11.8421 15.0674 11.9417 15.3106 11.8214C15.5538 11.7011 15.6534 11.4063 15.5331 11.1631C15.4128 10.9199 15.1181 10.8203 14.8749 10.9407Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0415 12.362C11.8074 12.4778 11.7115 12.7615 11.8274 12.9956C11.9432 13.2297 12.2268 13.3255 12.4609 13.2097C12.695 13.0939 12.7909 12.8102 12.675 12.5761C12.5592 12.3421 12.2756 12.2462 12.0415 12.362Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20556 13.7663C8.97147 13.8821 8.8756 14.1658 8.99142 14.3999C9.10724 14.6339 9.3909 14.7298 9.62498 14.614C9.85906 14.4982 9.95493 14.2145 9.83911 13.9804C9.72329 13.7464 9.43964 13.6505 9.20556 13.7663Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3812 15.1881C6.16102 15.2971 6.06924 15.5686 6.17818 15.7888C6.28712 16.009 6.55865 16.1007 6.77883 15.9918C6.99901 15.8828 7.09079 15.6113 6.98184 15.3911C6.8729 15.171 6.60138 15.0792 6.3812 15.1881Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.54979 16.6114C3.33512 16.7176 3.24891 16.9727 3.35513 17.1874C3.46135 17.4021 3.71641 17.4883 3.93108 17.3821C4.14576 17.2758 4.23197 17.0208 4.12576 16.8061C4.01954 16.5914 3.76447 16.5052 3.54979 16.6114Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.734853 18.0522C0.54333 18.147 0.464888 18.3791 0.55965 18.5706C0.654412 18.7621 0.886496 18.8406 1.07802 18.7458C1.26954 18.651 1.34798 18.419 1.25322 18.2274C1.15846 18.0359 0.926377 17.9575 0.734853 18.0522Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8401 -1.15365C31.5179 -0.994208 31.3859 -0.603727 31.5453 -0.281482C31.7048 0.0407632 32.0953 0.172742 32.4175 0.0133013C32.7397 -0.146139 32.8717 -0.536621 32.7123 -0.858866C32.5528 -1.18111 32.1624 -1.31309 31.8401 -1.15365Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0116 0.263785C28.6979 0.419025 28.57 0.797512 28.7252 1.11127C28.8804 1.42502 29.2589 1.55295 29.5727 1.39771C29.8864 1.24247 30.0144 0.863981 29.8591 0.550225C29.7039 0.236469 29.3254 0.108544 29.0116 0.263785Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1873 1.68561C25.89 1.83268 25.7622 2.19743 25.912 2.50017C26.0618 2.80292 26.4238 2.92528 26.7265 2.77549C27.0293 2.6257 27.1517 2.26367 27.0019 1.96092C26.8521 1.65817 26.49 1.53582 26.1873 1.68561Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3612 3.11764C23.0754 3.25903 22.9584 3.60531 23.0998 3.89108C23.2412 4.17684 23.5874 4.29388 23.8732 4.15249C24.159 4.0111 24.276 3.66483 24.1346 3.37906C23.9932 3.0933 23.647 2.97625 23.3612 3.11764Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5327 4.53703C20.2561 4.67391 20.1428 5.00914 20.2796 5.28579C20.4165 5.56243 20.7517 5.67573 21.0284 5.53886C21.305 5.40198 21.4183 5.06675 21.2815 4.7901C21.1446 4.51346 20.8093 4.40016 20.5327 4.53703Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7084 5.96276C17.4439 6.09362 17.3355 6.41411 17.4664 6.67859C17.5973 6.94308 17.9178 7.0514 18.1822 6.92054C18.4467 6.78968 18.555 6.46919 18.4242 6.20471C18.2933 5.94022 17.9728 5.8319 17.7084 5.96276Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8779 7.38605C14.6192 7.51406 14.519 7.824 14.6443 8.0772C14.7696 8.33041 15.0823 8.43609 15.3355 8.31081C15.5887 8.18552 15.6944 7.87286 15.5691 7.61966C15.4438 7.36645 15.1311 7.26077 14.8779 7.38605Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0455 8.79568C11.7978 8.91823 11.6977 9.21444 11.8203 9.46214C11.9428 9.70984 12.2391 9.80996 12.4868 9.6874C12.7345 9.56484 12.8346 9.26864 12.712 9.02093C12.5895 8.77323 12.2932 8.67312 12.0455 8.79568Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22705 10.2273C8.99297 10.3431 8.8971 10.6267 9.01292 10.8608C9.12874 11.0949 9.41238 11.1908 9.64646 11.0749C9.88055 10.9591 9.97642 10.6755 9.86061 10.4414C9.74479 10.2073 9.46113 10.1114 9.22705 10.2273Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39175 11.6466C6.16678 11.758 6.07463 12.0306 6.18594 12.2555C6.29725 12.4805 6.56986 12.5726 6.79482 12.4613C7.01978 12.35 7.11192 12.0774 7.00061 11.8524C6.8893 11.6275 6.61671 11.5353 6.39175 11.6466Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56933 13.0704C3.35466 13.1766 3.26845 13.4317 3.37466 13.6464C3.48088 13.861 3.73596 13.9472 3.95063 13.841C4.16531 13.7348 4.25151 13.4797 4.14529 13.2651C4.03907 13.0504 3.78401 12.9642 3.56933 13.0704Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.741828 14.4918C0.538161 14.5925 0.454736 14.8394 0.555506 15.043C0.656276 15.2467 0.903111 15.3301 1.10678 15.2294C1.31044 15.1286 1.39388 14.8817 1.29311 14.6781C1.19234 14.4744 0.945494 14.391 0.741828 14.4918Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.366 -0.445254C23.0688 -0.298184 22.9409 0.066568 23.0907 0.369315C23.2405 0.672062 23.6025 0.794419 23.9053 0.644625C24.208 0.494832 24.3304 0.132808 24.1806 -0.16994C24.0308 -0.472687 23.6688 -0.595047 23.366 -0.445254Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5409 0.977023C20.2546 1.11865 20.1378 1.46422 20.2795 1.75046C20.4211 2.03669 20.7667 2.15349 21.0529 2.01187C21.3391 1.87025 21.4559 1.52467 21.3143 1.23844C21.1727 0.952202 20.8271 0.8354 20.5409 0.977023Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7085 2.39836C17.4278 2.53726 17.3192 2.87189 17.4554 3.14711C17.5916 3.42233 17.9289 3.53636 18.2042 3.40018C18.4794 3.26401 18.5934 2.92666 18.4572 2.65143C18.3211 2.37621 17.9837 2.26219 17.7085 2.39836Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8926 3.84113C14.6339 3.96914 14.5337 4.27908 14.659 4.53228C14.7843 4.78549 15.0969 4.89117 15.3501 4.76588C15.6033 4.6406 15.709 4.32794 15.5837 4.07473C15.4584 3.82153 15.1458 3.71585 14.8926 3.84113Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0661 5.25857C11.8184 5.38112 11.7182 5.67733 11.8408 5.92504C11.9633 6.17274 12.2596 6.27285 12.5073 6.15029C12.755 6.02773 12.8551 5.73153 12.7325 5.48382C12.61 5.23612 12.3138 5.13601 12.0661 5.25857Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23681 6.68623C9.00011 6.80334 8.90828 7.0886 9.02267 7.31979C9.13705 7.55097 9.42504 7.64832 9.65623 7.53393C9.88742 7.41954 9.98475 7.13155 9.87036 6.90036C9.75597 6.66917 9.468 6.57185 9.23681 6.68623Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40087 8.08858C6.16418 8.20569 6.07235 8.49094 6.18674 8.72213C6.30112 8.95331 6.5891 9.05066 6.82029 8.93627C7.05148 8.82189 7.14881 8.53389 7.03442 8.30271C6.92004 8.07152 6.63206 7.97419 6.40087 8.08858Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57338 9.50796C3.34842 9.61927 3.25628 9.89186 3.36759 10.1168C3.4789 10.3418 3.7515 10.4339 3.97646 10.3226C4.20143 10.2113 4.29355 9.93871 4.18224 9.71375C4.07094 9.48879 3.79834 9.39665 3.57338 9.50796Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.743154 10.9317C0.528479 11.038 0.442273 11.293 0.54849 11.5077C0.654707 11.7224 0.909769 11.8086 1.12444 11.7024C1.33912 11.5962 1.42533 11.3411 1.31912 11.1264C1.2129 10.9117 0.957829 10.8255 0.743154 10.9317Z",
    fill: "#3E6B59",
    fillOpacity: 0.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipPathImage);
export default __webpack_public_path__ + "static/media/clip_path_image.0a9e83d3f28c207c8f86b57ec08d4603.svg";
export { ForwardRef as ReactComponent };